<template>
  <div>
    <div class="subscription-loader">
      <mds-loader v-if="isLoading" aria-label="Medium Loader"></mds-loader>
    </div>
      <div class="subscription-support-alert" tinted>
          <mds-alert v-if="bPastDueError" variation="error" size="small" :list="lstPastDueError" persistent>
          </mds-alert>
      </div>
    <mds-layout-grid>
      <mds-row>
        <mds-col :cols="12">
          <div class="subscription-alert" v-if="customAlertSuccess" tinted>
            <mds-alert
              variation="success"
              size="small"
              :list="lstSuccess"
              @mds-alert-dismissed="customAlertSuccess = false"
            >
            </mds-alert>
          </div>
          <div class="subscription-alert" v-if="customAlertError" tinted>
            <mds-alert
              variation="error"
              title="Form Error"
              size="small"
              :list="lstError"
              @mds-alert-dismissed="customAlertError = false"
            >
            </mds-alert>
          </div>
          <div class="subscription-alert" v-if="OmahaCustomer" tinted>
            <mds-alert
              variation="error"
              title=""
              size="small"
              :list="lstOmahaCustomerError"
              @mds-alert-dismissed="OmahaCustomer = false"
            >
            </mds-alert>
          </div>
        </mds-col>
      </mds-row>
    </mds-layout-grid>
    <div v-for="sub in lstSubscription" :key="sub.SubscriptionID">
      <div v-if="sub.ProductCode == 'NF00000001'" class="subscription-heading-top">
        FundInvestor Subscription
      </div>
      <div v-if="sub.ProductCode == 'NM00000001'" class="subscription-heading-top">
        StockInvestor Subscription
      </div>
      <div v-if="sub.ProductCode == 'NDI0000001'" class="subscription-heading-top">
        DividendInvestor Subscription
      </div>
      <div v-if="sub.ProductCode == 'NET0000001'" class="subscription-heading-top">
        ETFInvestor Subscription
      </div>

      <div v-if="sub.DigitalAccess && !sub.IsUserInStripe">
        <mds-layout-grid>
          <mds-row>
            <mds-col :cols="12">
              <div class="subscription-box">
                <div style="margin: 23px">
                  <div class="subscription-product-title">Digital Access Active</div>
                </div>
              </div>
            </mds-col>
          </mds-row>
        </mds-layout-grid>
      </div>
      <div v-if="!sub.DigitalAccess && !sub.IsUserInStripe">
        <mds-layout-grid>
          <mds-row>
            <mds-col :cols="12">
              <div class="subscription-box">
                <div style="margin: 23px">
                  <div class="subscription-product-title">{{ sub.Term }}</div>
                  <!-- <div v-if="sub.ProductCode == 'NF00000001'" class="subscription-product-title">FundInvestor Term</div>
                                <div v-if="sub.ProductCode == 'NM00000001'" class="subscription-product-title">StockInvestor Term</div>
                                <div v-if="sub.ProductCode == 'NDI0000001'" class="subscription-product-title">DividendInvestor Term</div>
                                <div v-if="sub.ProductCode == 'NET0000001'" class="subscription-product-title">ETFInvestor Term</div> -->
                  <div class="subscription-term" v-html="sub.ProductTerm">
                    <!-- {{sub.ProductTerm}} -->
                  </div>

                  <div class="subscription-product-title" style="margin-top: 18px">
                    Last Payment
                  </div>
                  <div class="subscription-term">
                    ${{ checkTotalAmount(sub.TotAmount) }} on {{ sub.LastPaymentDate }}
                  </div>

                  <div class="subscription-product-title" style="margin-top: 18px">
                    <span v-if="sub.IsTrial"> Trial End Date</span>
                    <span v-else> Next Payment</span>
                  </div>
                  <div class="subscription-term">
                    ${{ checkTotalAmount(sub.TotAmount) }} on
                    {{ sub.NextPaymentDate }}
                  </div>

                  <div v-if="sub.CurrentMonth">
                    <div class="subscription-border"></div>

                    <div style="margin-top: 11px">
                      <mds-icon
                        class="exclaim-circle-fill"
                        name="exclaim-circle-fill"
                        size="small"
                      ></mds-icon>
                      <span
                        v-if="sub.IsTrial"
                        class="subscription-term"
                        style="margin-left: 5px"
                        >Your free trial will end on {{ formatDate(sub.EndDate) }}.</span
                      >
                      <span v-else class="subscription-term" style="margin-left: 5px"
                        >Your subscription will end on
                        {{ formatDatestripe(sub.subscriptionEndDate) }}.</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </mds-col>
          </mds-row>
        </mds-layout-grid>
      </div>

      <div v-if="!sub.DigitalAccess && sub.IsUserInStripe">
        <mds-layout-grid>
          <mds-row>
            <mds-col :cols="12">
              <div class="subscription-box">
                <div style="margin: 23px">
                  <mds-layout-grid>
                    <mds-row>
                      <mds-col
                        :cols="6"
                        :cols-at-l="6"
                        :cols-at-xl="6"
                        :cols-at-m="6"
                        :cols-at-s="6"
                      >
                        <div class="subscription-product-title">{{ sub.Term }}</div>

                        <div class="subscription-term">
                          {{ sub.ProductTerm }}
                        </div>
                      </mds-col>

                      <mds-col
                        :cols="6"
                        :cols-at-l="6"
                        :cols-at-xl="6"
                        :cols-at-m="6"
                        :cols-at-s="6"
                        style="float: right"
                      >
                        <div v-if="sub.InvoiceStatus == 'paid'" style="float: inherit" @click="downloadInvoice(sub.InvoicePdf)">
                          <span class="subscription-view-invoice">View Invoice &nbsp;</span>
                          <mds-icon
                            name="document"
                            size="small"
                            style="margin-bottom: -2px"
                          ></mds-icon>
                        </div>
                      </mds-col>
                    </mds-row>
                  </mds-layout-grid>

                  <div class="subscription-product-title" style="margin-top: 18px">
                    Last Payment
                  </div>
                  <div class="subscription-term" v-if="sub.InvoiceStatus == 'paid'">
                    ${{ sub.TotAmount }} on {{ sub.EndDate }}
                    <span
                      v-if="sub.LastDiscountedPrice > 0"
                      class="subscription-separator"
                      >•</span
                    >
                    <span v-if="sub.LastDiscountedPrice > 0" class="subscription-promo"
                      >Promotional Rate —
                      <span>${{ sub.LastDiscountedPrice }}</span></span
                    >
                  </div>
                  <div class="subscription-term"  v-if="sub.InvoiceStatus != 'paid'">
                    &mdash;
                  </div>

                  <div class="subscription-product-title" style="margin-top: 18px">
                    <span> Next Payment</span>
                  </div>
                  <div class="subscription-term">
                    ${{ sub.NextPaymentAmount }} on {{ sub.NextPaymentDate }}
                    <span
                      v-if="sub.NextDiscountedPrice > 0"
                      class="subscription-separator"
                      >•</span
                    >
                    <span v-if="sub.NextDiscountedPrice > 0" class="subscription-promo"
                      >Promotional Rate —
                      <span>${{ sub.NextDiscountedPrice }}</span></span
                    >
                  </div>

                  <div>
                    <div class="subscription-border"></div>

                    <div class="subscription-text-layout-grid-container" >
                      <mds-layout-grid>
                        <mds-row>
                          <mds-col
                            :cols="6"
                            :cols-at-l="8"
                            :cols-at-xl="8"
                            :cols-at-m="8"
                            :cols-at-s="8"
                          >
                            <mds-icon
                              v-if="sub.CurrentMonth"
                              class="exclaim-circle-fill"
                              name="exclaim-circle-fill"
                              size="small"
                            ></mds-icon>
                            <span
                              v-if="sub.CurrentMonth"
                              class="subscription-term"
                              style="margin-left: 5px"
                              >Your subscription will end on {{ sub.EndDate }}.</span
                            >
                          </mds-col>

                          <mds-col
                            :cols="6"
                            :cols-at-l="4"
                            :cols-at-xl="4"
                            :cols-at-m="4"
                            :cols-at-s="4"
                            style="float: right"
                          >
                            <div style="float: inherit">
                              <span
                                class="cancel-subscription-text-container"
                                v-if="
                                  sub.subscriptionCancellationDate == null ||
                                  sub.subscriptionCancellationDate == ''
                                "
                                @click="
                                  populateCancelSubscriptionPropObject(
                                    sub.Term,
                                    sub.SubscriptionID
                                  )
                                "
                                >Cancel Subscription
                              </span>
                            </div>
                          </mds-col>
                        </mds-row>
                      </mds-layout-grid>
                    </div>
                  </div>
                </div>
              </div>
            </mds-col>
          </mds-row>
        </mds-layout-grid>
      </div>

      <div style="margin-bottom: 32px"></div>
    </div>
    <div v-if="NoActiveSubscription">
      <mds-layout-grid>
        <mds-row>
          <mds-col :cols="12">
            <div class="subscription-box">
              <div style="margin: 23px">
                <div class="subscription-product-title">No Active Subscriptions</div>
              </div>
            </div>
          </mds-col>
        </mds-row>
      </mds-layout-grid>
    </div>
    <div v-if="billInfo" class="subscription-heading-top" style="margin-top: 32px;margin-bottom: 4px;">
      Billing Information
    </div>
    <mds-layout-grid>
      <mds-row>
        <mds-col :cols="12">
          <!-- Payment Method -->
          <div v-if="ifPaymentMethod">
            <div class="subscription-box-payment-method">             
              <div class="subscription-main-container">
                <div
                    v-if="isCreditCardInvestorText"
                    class="investor-subscriber-credit-card-not-changes-text-div"
                  >
                    <p class="investor-subscriber-credit-card-not-changes-text-container">
                      If you’re a Morningstar Investor subscriber, changes made to your
                      payment method on this page will not apply to your Investor account.
                    </p>
                  </div>
                <div style="margin-top: 21px">
                  <div class="payment-method-text-and-remove-button-container">
                    <div class="payment-heading">Payment Method</div>

                    
                    <div
                      v-if="removebutton"
                      class="remove-button-on-credit-card-container"
                    >
                      <mds-button
                        variation="flat"
                        size="medium"
                        icon-right="remove"
                        @click="CreditCardUpdateCancel()"
                      >
                      </mds-button>
                    </div>
                  </div>


                  <div v-if="noProductAccess()">&mdash;</div>                

                  <!-- Display the first set of credit cards -->
                  <div v-if="firstCreditCard.length > 0" class="first-credit-card-text">
                    <div
                      class="first-credit-card-number-container"
                     
                    >
                      <p class="credit-card-number-text">
                        •••••••• {{ firstCreditCard[0].cardNumber }}
                      </p>
                    </div>

                    <div
                      v-if="ifFirstCreditCardPrimary && !isPrimaryTagResponsiveToggle"
                      class="primary-tag-for-first-card"
                    >
                      <mds-tag> Primary </mds-tag>
                    </div>

                    <div
                      v-if="isPrimaryTagResponsiveToggle"
                      class="primary-tag-for-first-card"
                    >
                      <mds-tag v-if="ifFirstCreditCardPrimaryResponsive">
                        Primary</mds-tag
                      >
                    </div>

                    <div v-if="editbutton" class="first-credit-card-edit-button">
                      <mds-button
                        variation="flat"
                        size="medium"
                        icon-right="pencil"
                        @click="FirstCreditCardEditOperation()"
                      >
                        Manage
                      </mds-button>
                    </div>

                    <div
                      v-if="editafterapply"
                      class="edit-and-remove-for-first-cc-container"
                    >
                      <div
                        v-if="firstCCSetPrimaryButton"
                        class="set-primary-button-container"
                      >
                        <mds-button
                          variation="flat"
                          size="medium"
                          @click="setPrimaryFirstCreditCard()"
                        >
                          Set Primary
                        </mds-button>
                      </div>
                      <!--<div>
                        <p class="edit-text-after-apply">Edit</p>
                      </div>-->
                      <div class="first-credit-card-remove-container">
                        <mds-button
                          variation="flat"
                          size="medium"
                          @click="removeFirstCreditCard()"
                        >
                          Remove
                        </mds-button>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="isSecondCreditCardBorderRequired"
                    class="border-for-credit-cards"
                  ></div>

                  <div
                    v-if="addNewPaymentMethodButton"
                    class="add-new-payment-method-container"
                  >
                    <mds-button
                      variation="secondary"
                      icon="plus"
                      type="button"
                      size="small"
                      @click="AddNewCreditCard()"
                    >
                      Add New Payment Method
                    </mds-button>
                  </div>

                  <!-- Credit Card Fields for Add -->
                  <div v-if="creditCardFields">
                    <form @submit.prevent="submitPayment" class="stripe-payment-form">
                      <div class="field">
                        <label for="card-number" class="stripe-payment-form-label">
                          Card Number <span class="required">*</span>
                        </label>
                        <div id="card-number" class="stripe-element"></div>
                        <span class="error" v-if="cardNumberError">{{ cardNumberError  }}</span>
                      </div>

                      <div class="flex-container">
                        <div class="field flex-item">
                          <label for="card-expiry" class="stripe-payment-form-label">
                            Expiration Date <span class="required">*</span>
                          </label>
                          <div id="card-expiry" class="stripe-element"></div>
                          <span class="error-for-date" v-if="cardExpiryError">{{
                            cardExpiryError 
                          }}</span>
                        </div>
                        <div class="field flex-item">
                          <label for="card-cvc" class="stripe-payment-form-label">
                            Security Code <span class="required">*</span>
                          </label>
                          <div id="card-cvc" class="stripe-element"></div>
                          <span class="error-for-cvc" v-if="cardCVVError">{{
                            cardCVVError 
                          }}</span>
                        </div>
                      </div>
                    </form>
                    <div class="credit-card-below-text">
                      <p class="credit-card-below-text-para">
                        By providing your card information, you allow Morningstar, Inc. to
                        charge your primary card for future payments in accordance with
                        their terms
                      </p>
                    </div>
                  </div>

                  <!-- Display the second set of credit cards -->
                  <div
                    v-if="secondCreditCard.length > 0"
                    class="second-credit-card-edit-button"
                  >
                    <div
                      class="second-credit-card-number-container"
                      
                    >
                      <p class="credit-card-number-text">
                        •••••••• {{ secondCreditCard[0].cardNumber }}
                      </p>
                    </div>

                    <div
                      v-if="ifsecondCreditCardPrimary && !isPrimaryTagResponsiveToggle"
                      class="primary-tag-for-second-card"
                    >
                      <mds-tag> Primary </mds-tag>
                    </div>

                    <div
                      v-if="isPrimaryTagResponsiveToggle"
                      class="primary-tag-for-second-card"
                    >
                      <mds-tag v-if="ifSecondCreditCardPrimaryResponsive">
                        Primary</mds-tag
                      >
                    </div>

                    <div
                      v-if="editafterapplysecond"
                      class="edit-and-remove-for-first-cc-container"
                    >
                      <div
                        v-if="secondCCSetPrimaryButton"
                        class="set-primary-button-container"
                      >
                        <mds-button
                          variation="flat"
                          size="medium"
                          @click="setPrimarySecondCreditCard()"
                        >
                          Set Primary
                        </mds-button>
                      </div>

                      <!--<div>
                        <p class="edit-text-after-apply">Edit</p>
                      </div>-->
                      <div class="first-credit-card-remove-container">
                        <mds-button
                          variation="flat"
                          size="medium"
                          @click="removeSecondCreditCard()"
                        >
                          Remove
                        </mds-button>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="isEditButtonClicked"
                  class="credit-card-button-container-class"
                >
                  <mds-button-container right-aligned>
                    <mds-button
                      v-if="cancelCreditCardButton"
                      variation="secondary"
                      size="small"
                      type="button"
                      @click="CreditCardUpdateCancel()"
                    >
                      Cancel
                    </mds-button>
                    <mds-button
                      v-if="secondCreditCardAddButton"
                      variation="primary"
                      size="small"
                      type="button"
                      @click="submitPayment"
                      :disabled="!creditCardValid"
                    >
                      Add
                    </mds-button>
                    <mds-button
                      v-if="btnForCreditCardLoading"
                      style="margin-left: 10px; width: 44.6px; height: 26px"
                      variation="primary"
                      loading
                      >Loading</mds-button
                    >
                    <!-- <mds-button
                      v-if="saveCreditCardButton"
                      variation="primary"
                      size="small"
                      type="button"
                    >
                      Save
                    </mds-button>
                    -->
                  </mds-button-container>
                </div>
              </div>
            </div>
          </div>

          <!-- Address -->
          <div v-if="AddressDisplay" id="subscription-address-display">
            <div class="subscription-box" >
              <div style="margin: 23px">
                <mds-layout-grid>
                  <mds-row>
                    <mds-col
                      :cols="9"
                      :cols-at-l="10"
                      :cols-at-xl="10"
                      :cols-at-m="9"
                      :cols-at-s="9"
                    >
                      <span class="subscription-address-heading"
                        >Updating this information does not update your print subscription
                        details;</span
                      ><span class="subscription-address-secondary">
                        please email
                        <a
                          class="subscription-address-support-links"
                          href="mailto:newslettersupport@morningstar.com"
                          >newslettersupport@morningstar.com</a
                        >
                        to request an address update for your print deliveries.</span
                      >
                    </mds-col>

                    <mds-col
                      :cols="3"
                      :cols-at-l="2"
                      :cols-at-xl="2"
                      :cols-at-m="3"
                      :cols-at-s="3"
                      style="float: right"
                    >
                      <div
                        style="float: inherit"
                        class="subscription-secondarytext"
                        @click="AddressClick()"
                      >
                        Edit &nbsp;<mds-icon name="pencil" size="small"></mds-icon>
                      </div>
                    </mds-col>
                  </mds-row>
                </mds-layout-grid>
                <div style="margin-top: 29px">
                  <div class="subscription-heading">Billing Address</div>
                  <div class="subscription-text">{{ Address }}</div>
                  <div v-if="addressBlank" style="margin-top: 8px;" class="subscription-text">&mdash;</div>
                </div>
              </div>
            </div>
          </div>
          <!-- Address -->
          <div style="margin-top: 24px" v-if="EditAddress">
            <div class="subscription-address-editbox" id="subscription-address-id">
              <div style="margin:23px 23px 0px 23px;">
                <mds-layout-grid>
                  <mds-row>
                    <mds-col
                      :cols="12"
                      :cols-at-l="12"
                      :cols-at-xl="12"
                      :cols-at-m="12"
                      :cols-at-s="12"
                    >
                      <span class="subscription-address-heading"
                        >Updating this information does not update your print subscription
                        details;</span
                      ><span class="subscription-address-secondary">
                        please email
                        <a
                          class="subscription-address-support-links"
                          href="mailto:newslettersupport@morningstar.com"
                          >newslettersupport@morningstar.com</a
                        >
                        to request an address update for your print deliveries.</span
                      >
                      <div style="margin-top:20px;"  class="subscription-address-secondary">
                        If you’re a Morningstar Investor subscriber, changes made to your billing address on this page will not apply to your Investor account.
                      </div>

                    </mds-col>
                  </mds-row>
                </mds-layout-grid>
              </div>
              <p id ="billingAddress">
                Billing Address
              </p>
              <div style="margin-bottom:23px;padding-top: 5px;">
              
                <div class="subscription-address-editdiv">
                  <div class="subscription-address-inside-flex">
                    
                    <mds-select
                      :error="CountryError"
                      size="medium"
                      v-model="txtCountry"
                      label="Country"
                      placeholder="Please select country"
                      @change="countryChange()"
                      required
                      class="subscription-heading-textbox"
                    >
                      <option
                        v-bind:key="country.CountryCode"
                        :value="country.Country"
                        v-for="country in lstCountry"
                      >
                        {{ country.Country }}
                      </option>
                    </mds-select>
                    <span class="subscription-forms-error" v-if="CountryError">{{
                      CountryErrorMsg
                    }}</span>
                  </div>
                </div>
                <div class="subscription-address-editdiv">
                  <div class="subscription-address-inside-flex">
                    <mds-input
                      size="medium"
                      :error="Address1Error"
                      v-model="txtAddress1"
                      label="Billing Address"
                      type="text"
                      required
                      class="subscription-heading-textbox"
                    ></mds-input>
                    <span class="subscription-forms-error" v-if="Address1Error">{{
                      txtAddress1ErrorMsg
                    }}</span>
                  </div>
                </div>
                <div class="subscription-address-editdiv" v-if="!IsUserInStripe">
                  <div class="subscription-address-inside-flex">
                    <mds-input
                      size="medium"
                      v-model="txtAddress2"
                      label="Billing Address 2"
                      type="text"
                      class="subscription-heading-textbox"
                    ></mds-input>
                    <!-- <span class="my-profile-forms-error" v-if="Address2Error">{{txtAddress2ErrorMsg}}</span> -->
                  </div>
                </div>
                <div class="subscription-address-editdiv subscription-city">
                  <div class="subscription-address-inside-flex">
                    <mds-input
                      size="medium"
                      :error="cityError"
                      v-model="txtCity"
                      label="City"
                      type="text"
                      required
                      class="subscription-heading-textbox"
                    ></mds-input>
                    <span class="subscription-forms-error" v-if="cityError">{{
                      txtCityErrorMsg
                    }}</span>
                  </div>
                </div>
                <div class="subscription-address-editdiv subscription-city">
                  <div class="subscription-address-inside-flex">
                    <div v-if="UsaState">
                      <div v-if="IsUserInStripe">
                        <mds-select
                          :error="USAStateError"
                          size="medium"
                          v-model="txtUsaState"
                          label="State"
                          placeholder="Select state"
                          required
                          class="subscription-heading-textbox"
                        >
                          <option
                            v-bind:key="usa.StateAbbr"
                            :value="usa.StateName"
                            v-for="usa in lstUsaState"
                          >
                            {{ usa.StateName }}
                          </option>
                        </mds-select>
                        <span class="subscription-forms-error" v-if="USAStateError"
                          >State is required</span
                        >
                      </div>
                      <div v-if="!IsUserInStripe">
                        <mds-select
                          :error="USAStateError"
                          size="medium"
                          v-model="txtUsaState"
                          label="State"
                          placeholder="Select state"
                          required
                          class="subscription-heading-textbox"
                        >
                          <option
                            v-bind:key="usa.StateAbbr"
                            :value="usa.StateAbbr"
                            v-for="usa in lstUsaState"
                          >
                            {{ usa.StateName }}
                          </option>
                        </mds-select>
                        <span class="subscription-forms-error" v-if="USAStateError"
                          >State is required</span
                        >
                      </div>
                    </div>
                    <div v-if="CanadaState">
                      <div v-if="IsUserInStripe">
                        <mds-select
                          :error="CanadaStateError"
                          size="medium"
                          v-model="txtCanadaState"
                          label="Province"
                          placeholder="Select Province"
                          class="subscription-heading-textbox"
                        >
                          <option
                            v-bind:key="can.StateAbbr"
                            :value="can.StateName"
                            v-for="can in lstCanadaState"
                          >
                            {{ can.StateName }}
                          </option>
                        </mds-select>
                        <span class="subscription-forms-error" v-if="CanadaStateError"
                          >Province is required</span
                        >
                      </div>
                      <div v-if="!IsUserInStripe">
                        <mds-select
                          :error="CanadaStateError"
                          size="medium"
                          v-model="txtCanadaState"
                          label="Province"
                          placeholder="Select Province"
                          class="subscription-heading-textbox"
                        >
                          <option
                            v-bind:key="can.StateAbbr"
                            :value="can.StateName"
                            v-for="can in lstCanadaState"
                          >
                            {{ can.StateName }}
                          </option>
                        </mds-select>
                        <span class="subscription-forms-error" v-if="CanadaStateError"
                          >Province is required</span
                        >
                      </div>
                    </div>
                    <div v-if="OtherState">
                      <mds-input
                        size="medium"
                        v-model="txtOtherState"
                        label="State/Province/APO"
                        type="text"
                        class="subscription-heading-textbox"
                      ></mds-input>
                      <!-- <span class="my-profile-forms-error" v-if="OtherStateError">{{txtStateErrorMsg}}</span> -->
                    </div>
                  </div>
                </div>
                <div class="subscription-address-editdiv">
                  <div class="subscription-address-inside-flex">
                    <mds-input
                      size="medium"
                      :error="zipCodeError"
                      v-model="txtZipCode"
                      :label="lblZipCode"
                      type="text"
                      required
                      class="subscription-heading-textbox"
                    ></mds-input>
                    <span class="subscription-forms-error" v-if="zipCodeError">{{
                      txtZipCodeErrorMsg
                    }}</span>
                  </div>
                </div>

                <mds-layout-grid>
                  <mds-row>
                    <mds-col :cols="12" style="float: right">
                      <div class="subscription-address-btn">
                        <mds-button variation="secondary" @click="CancelAddress()">
                          Cancel
                        </mds-button>
                        <mds-button
                          v-if="btnAddressSave"
                          variation="primary"
                          style="margin-left: 10px"
                          @click="SaveAddress()"
                        >
                          Save
                        </mds-button>
                        <mds-button
                          v-if="btnAddressLoading"
                          style="margin-left: 10px; width: 60px"
                          variation="primary"
                          loading
                          >Loading</mds-button
                        >
                      </div>
                    </mds-col>
                  </mds-row>
                </mds-layout-grid>
              </div>
            </div>
          </div>
        </mds-col>
      </mds-row>
    </mds-layout-grid>

    <cancel-subscription
      v-if="this.cancelSubscriptionPropObject.modalStatus"
      :cancel-subscription-data="cancelSubscriptionPropObject"
      @resetCancelSubscriptionModalValue="resetCancelSubscriptionModalStatus"
      @subscriptionCancellationStatusValue="subscriptionCancellationStatus"
    ></cancel-subscription>
  </div>
</template>

<script>
import { MdsLayoutGrid, MdsRow, MdsCol } from "@mds/layout-grid";
import MdsIcon from "@mds/icon";
import MdsLoader from "@mds/loader";
import MdsAlert from "@mds/alert";
import { MdsButton, MdsButtonContainer } from "@mds/button";
import MdsInput from "@mds/input";
import { fetchData, postData, putData } from "@/utilities/API/apiUtility";
import MdsSelect from "@mds/select";
import CancelSubscription from "@/components/MyAccount/CancelSubscription.vue";
import { loadStripe } from "@stripe/stripe-js";
import { MdsTag } from "@mds/tag";
import { mapState } from "vuex";

export default {
  name: "subscription",
  components: {
    MdsLayoutGrid,
    MdsRow,
    MdsCol,
    MdsIcon,
    MdsLoader,
    MdsAlert,
    MdsButton,
    MdsInput,
    MdsSelect,
    CancelSubscription,
    MdsButtonContainer,
    MdsTag,
  },
  data() {
    return {
      customAlertError: false,
      lstError: [],
      lstPastDueError:[],
      bPastDueError:false,
      customAlertSuccess: false,
      lstSuccess: [],
      lstOmahaCustomerError: [],
      OmahaCustomer: false,

      isLoading: true,
      userID: "",
      userDetails: [],
      userDetailsStripe: [],
      lstSubscription: [],
      lstSubscriptionStripe: [],
      lstSubscriptionOmaha: [],

      lstMFI: [],
      lstMSI: [],
      lstMDI: [],
      lstMEI: [],
      MEIProductAccess: false,
      MDIProductAccess: false,
      MSIProductAccess: false,
      MFIProductAccess: false,
      productDataRoles: "",
      NoActiveSubscription: false,

      // Address
      AddressDisplay: false,
      EditAddress: false,
      CountryErrorMsg: "Country is required",
      CountryError: false,
      txtCountry: "",
      lstCountry: [],

      Address1Error: false,
      txtAddress1: "",
      txtAddress1ErrorMsg: "Address is required",
      Address2Error: false,
      txtAddress2: "",
      txtAddress2ErrorMsg: "Please enter address 2",
      cityError: false,
      txtCity: "",
      txtCityErrorMsg: "City is required",
      zipCodeError: false,
      txtZipCode: "",
      txtZipCodeErrorMsg: "",

      lstUsaState: this.$store.state.country.USAstateslist,
      lstCanadaState: this.$store.state.country.Canadastateslist,

      UsaState: false,
      CanadaState: false,
      OtherState: false,

      txtUsaState: "",
      txtCanadaState: "",
      txtOtherState: "",

      USAStateError: false,
      CanadaStateError: false,
      OtherStateError: false,

      txtStateErrorMsg: "State/Province/APO is required",
      //txtStateSelectErrorMsg: "Select state",
      txtStateSelectErrorMsg: "",
      SaveStateValue: "",
      btnAddressLoading: false,
      btnAddressSave: true,
      Address: "",
      IsUserInStripe: false,
      chkPhoneCall: false,
      billInfo: false,

      //Cancel Subscription
      cancelSubscriptionPropObject: {
        modalStatus: false,
        product: null,
        userID: null,
        StripeSubscriptionId: null,
      },

      //Credit Card
      stripeIdForCC: "",
      firstCreditCard: [], // Store the first credit card
      secondCreditCard: [], // Store the second credit card
      isSecondCreditCardBorderRequired: false,
      isEditButtonClicked: false,
      addNewPaymentMethodButton: false,
      editafterapply: false,
      editafterapplysecond: false,
      editbutton: true,
      creditCardFields: false,
      SecondCreditCardNumber: "",
      ExpirationDateForSecondCC: "",
      SecurityCodeForSecondCC: "",
      expirationDate: "",
      securityCode: "",
      expirationDateError: "",
      secondCreditCardAddButton: false,
      saveCreditCardButton: true,
      stripePublicKey: process.env.VUE_APP_STRIPE_PK,
      stripe: null,
      elements: null,
      cardNumberElement: null,
      cardExpiryElement: null,
      cardCvcElement: null,
      paymentMethodId: null,
      addCreditCardURL:
        process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_ADD_CREDIT_CARD_DETAILS,
      ifPaymentMethod: false,
      deleteCreditCardURL:
        process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_DELETE_CREDIT_CARD_DETAILS,
      ifFirstCreditCardPrimary: false,
      ifFirstCreditCardPrimaryResponsive: false,
      ifSecondCreditCardPrimaryResponsive: false,
      ifsecondCreditCardPrimary: false,
      firstCCSetPrimaryButton: false,
      secondCCSetPrimaryButton: false,
      setPrimaryCreditCardURL:
        process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_SET_CREDIT_CARD_AS_PRIMARY,
      cardNumberError: false,
      cardCVVError: false,
      cardExpiryError: false,
      isCardNumberValid: false,
      isCardExpiryValid: false,
      isCardCvcValid: false,
      isCreditCardInvestorText: false,
      cancelCreditCardButton: false,
      error: null,
      AddButtonForCreditCard: true,
      btnForCreditCardLoading: false,
      removebutton: false,
      isPrimaryTagResponsiveToggle: null,
      addressBlank:false,

      ValidateAddressAndCalculateTax:
        process.env.VUE_APP_BackEndAPI +
        process.env.VUE_APP_ValidateAddressAndCalculateTax,
        isValidAddress: true,
        isValidAddressForCreatingUserInstripe: false,
        taxAmountForMSI: "",
        taxAmountForMFI: "",
        taxAmountForMDI: "",
        taxAmountForMEI: ""
    };
  },

  async created() {
    // Initialize Stripe and Elements
  },
  computed: mapState({
    isDataTableResponsive: (state) => state.responsive.isDataTableResponsive,
    isDataTableResponsiveAlias: "isDataTableResponsive",
    isDataTableResponsiveState(state) {
      return state.responsive.isDataTableResponsive;
    },
    creditCardValid() {
      return this.isCardNumberValid && this.isCardExpiryValid && this.isCardCvcValid;
    },
  }),
  mounted() {
    this.isPrimaryTagResponsiveToggle = this.$store.state.responsive.isDataTableResponsive;
    this.setupStripe();
    if (this.secondCreditCard.length > 0) {
      this.isSecondCreditCardBorderRequired = true;
    }

    this.productDataRoles = this.$auth0.user["https://morningstar.com/uim_roles"];
    if (this.productDataRoles != undefined && this.productDataRoles != null) {
      this.MEIProductAccess = this.productDataRoles.includes("EI_MEMBER");
      this.MDIProductAccess = this.productDataRoles.includes("DI_MEMBER");
      this.MSIProductAccess = this.productDataRoles.includes("SI_MEMBER");
      this.MFIProductAccess = this.productDataRoles.includes("FI_MEMBER");
    }

    this.userID = this.$auth0.user["https://morningstar.com/mstar_id"];

    this.IsUserInStripe = this.$session.get("IsUserInStripe");
    if (this.userID) {
      if (this.IsUserInStripe) {
        this.lstCountry = this.$store.state.country.stripeCountryList;
        this.getUserDetailsStripe();
       
      } else {
        this.lstCountry = this.$store.state.country.contryList;
        this.getUserDetails();
      }
    }

    this.getUserDetails_Omaha_Stripe();
  },

  methods: {
    getUserDetails() {
      var getUserDetailsAPIURL =
        process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_GetUserDetails;
      getUserDetailsAPIURL = getUserDetailsAPIURL.replace("{userId}", this.userID);
      try {
        fetchData(getUserDetailsAPIURL, {
          headers: {
            Accept: "application/json",
          },
        })
          .then((response) => {
            if (response) {
              if (response.status == 200) {
                if (response.data) {
                  this.userDetails = response.data;
                  if (this.userDetails) {
                    if (this.userDetails["CustomerID"]) {
                      //this.getSubscriptionList(this.userDetails["CustomerID"]);
                      this.getPhoneCallValue(this.userDetails["CustomerID"]);
                    }
                    var Address_1 = "";
                    var Address_2 = "";
                    var City = "";
                    var State = "";
                    var ZipCode = "";
                    var Country = "";
                    if (this.userDetails["Address_1"]) {
                      Address_1 = this.userDetails["Address_1"];
                      this.txtAddress1 = this.userDetails["Address_1"];
                    }
                    if (this.userDetails["Address_2"]) {
                      Address_2 = this.userDetails["Address_2"];
                      this.txtAddress2 = this.userDetails["Address_2"];
                    }
                    if (this.userDetails["City"]) {
                      City = this.userDetails["City"];
                      this.txtCity = this.userDetails["City"];
                    }

                    if (this.userDetails["ZipCode"]) {
                      ZipCode = this.userDetails["ZipCode"];
                      this.txtZipCode = this.userDetails["ZipCode"];
                    }
                    if (this.userDetails["Country"]) {
                      Country = this.userDetails["Country"];
                      this.txtCountry = this.ChangeContryName(
                        this.userDetails["Country"]
                      );
                    }
                    if (this.userDetails["State"] != null) {
                      State = this.userDetails["State"];
                      if (this.txtCountry == "USA") {
                        this.UsaState = true;
                        this.txtUsaState = State;
                        this.lblZipCode = "ZIP Code";
                      } else if (this.txtCountry == "Canada") {
                        this.CanadaState = true;
                        this.txtCanadaState = State;
                        this.lblZipCode = "ZIP / Postal Code";
                      } else {
                        this.OtherState = true;
                        this.txtOtherState = State;
                        this.lblZipCode = "ZIP / Postal Code";
                      }
                    }
                    if (Address_1) {
                      this.Address =
                        Address_1 +
                        " " +
                        Address_2 +
                        " " +
                        City +
                        " " +
                        State +
                        ", " +
                        this.ChangeContryName(Country) +
                        " " +
                        ZipCode;
                    } else {
                      this.Address = this.ChangeContryName(Country) + " " + ZipCode;
                    }
                  }
                }
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
        // .finally(() => (this.isLoading = false));
      } catch (ex) {
        console.log(ex.message);
      }
    },
    getUserDetails_Omaha() {
      var getUserDetailsAPIURL =
        process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_GetUserDetails;
      getUserDetailsAPIURL = getUserDetailsAPIURL.replace("{userId}", this.userID);
      try {
        fetchData(getUserDetailsAPIURL, {
          headers: {
            Accept: "application/json",
          },
        })
          .then((response) => {
            if (response) {
              if (response.status == 200) {
                if (response.data) {
                  this.userDetails = response.data;
                  if (this.userDetails) {
                    if (this.userDetails["CustomerID"]) {
                      //this.getSubscriptionList(this.userDetails["CustomerID"]);
                      this.getPhoneCallValue(this.userDetails["CustomerID"]);
                    }
                    var Address_1 = "";
                    var Address_2 = "";
                    var City = "";
                    var State = "";
                    var ZipCode = "";
                    var Country = "";
                    if (this.userDetails["Address_1"]) {
                      Address_1 = this.userDetails["Address_1"];
                      this.txtAddress1 = this.userDetails["Address_1"];
                    }
                    if (this.userDetails["Address_2"]) {
                      Address_2 = this.userDetails["Address_2"];
                      this.txtAddress2 = this.userDetails["Address_2"];
                    }
                    if (this.userDetails["City"]) {
                      City = this.userDetails["City"];
                      this.txtCity = this.userDetails["City"];
                    }

                    if (this.userDetails["ZipCode"]) {
                      ZipCode = this.userDetails["ZipCode"];
                      this.txtZipCode = this.userDetails["ZipCode"];
                    }
                    if (this.userDetails["Country"]) {
                      Country = this.userDetails["Country"];
                      this.txtCountry = this.ChangeContryName(
                        this.userDetails["Country"]
                      );
                    }
                    if (this.userDetails["State"] != null) {
                      State = this.userDetails["State"];
                      if (this.txtCountry == "USA") {
                        this.UsaState = true;
                        this.txtUsaState = State;
                        this.lblZipCode = "Zip Code";
                      } else if (this.txtCountry == "Canada") {
                        this.CanadaState = true;
                        this.txtCanadaState = State;
                        this.lblZipCode = "Zip / Postal Code";
                      } else {
                        this.OtherState = true;
                        this.txtOtherState = State;
                        this.lblZipCode = "Zip / Postal Code";
                      }
                    }
                    if (Address_1) {
                      this.Address =
                        Address_1 +
                        " " +
                        Address_2 +
                        " " +
                        City +
                        " " +
                        State +
                        ", " +
                        this.ChangeContryName(Country) +
                        " " +
                        ZipCode;
                    } else {
                      this.Address = this.ChangeContryName(Country) + " " + ZipCode;
                    }
                  }
                }
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
        //.finally(() => (this.isLoading = false));
      } catch (ex) {
        console.log(ex.message);
      }
    },
    async getSubscriptionList_Omaha(customerId) {
      //this.isLoading = true;
      var GetSubscriptionUrl =
        process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_SubscriptionListUrl;
      //var GetSubscriptionUrl = "https://localhost:50377/subscription-list?customerId={customerId}";
      GetSubscriptionUrl = GetSubscriptionUrl.replace("{customerId}", customerId);

      try {
        const response = await fetchData(GetSubscriptionUrl, {
          headers: {
            Accept: "application/json",
          },
        });
        if (response && response.status === 200 && response.data) {
          const result = response.data;
          return result;
        }
      } catch (ex) {
        console.log(ex.message);
      }
    },
    formatDate(strDate) {
      if (strDate) {
        var temp = strDate.split("/");
        var date = "";
        var Month = "";
        var year = "";
        if (temp) {
          if (temp[0]) {
            Month = temp[0];
          }
          if (temp[1]) {
            date = temp[1];
          }
          if (temp[2]) {
            year = temp[2];
          }
        }
        var str = "";
        if (Month == "1") {
          str = "January";
        } else if (Month == "2") {
          str = "February";
        } else if (Month == "3") {
          str = "March";
        } else if (Month == "4") {
          str = "April";
        } else if (Month == "5") {
          str = "May";
        } else if (Month == "6") {
          str = "June";
        } else if (Month == "7") {
          str = "July";
        } else if (Month == "8") {
          str = "August";
        } else if (Month == "9") {
          str = "September";
        } else if (Month == "10") {
          str = "October";
        } else if (Month == "11") {
          str = "November";
        } else if (Month == "12") {
          str = "December";
        }
        return str + ". " + date + ", " + year;
      }
      return "";
    },
    checkCurrentMonth(EndDate) {
      var bValid = false;

      if (EndDate) {
        var temp = EndDate.split("/");
        var Month = "";
        var year = "";
        var day = "";
        if (temp) {
          if (temp[0]) {
            if (parseInt(temp[0]) < 10) {
              Month = "0" + temp[0];
            } else {
              Month = temp[0];
            }
          }
          if (temp[2]) {
            year = temp[2];
          }
          if (temp[1]) {
            if (parseInt(temp[1]) < 10) {
              day = "0" + temp[1];
            } else {
              day = temp[1];
            }
          }
          EndDate = Month + "/" + day + "/" + year;
        }
      }

      const today = new Date();
      const yyyy = today.getFullYear();
      let mm = today.getMonth() + 1; // Months start at 0!
      let dd = today.getDate();

      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;

      const formattedToday = mm + "/" + dd + "/" + yyyy;

      var date1 = new Date(formattedToday);
      var date2 = new Date(EndDate);

      var Difference_In_Time = date2.getTime() - date1.getTime();

      var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
      if (Difference_In_Days <= 30) {
        bValid = true;
      } else {
        bValid = false;
      }
      return bValid;
    },
    checkTotalAmount(Amt) {
      var Number;
      if (Amt == 0) {
        Number = Amt + ".00";
      } else if (Amt > 0) {
        var varName = Amt;
        var check = varName % 1;
        if (check) {
          Number = Amt;
        } else {
          Number = Amt + ".00";
        }
      }
      return Number;
    },
    ChangeContryName(Name) {
      var ContryName = "";
      if (Name) {
        if (Name.toUpperCase() == "USA") {
          ContryName = Name.toUpperCase();
        } else {
          var lowerText = Name.toLowerCase();
          var temp = lowerText.split(" ");
          if (temp) {
            for (var i in temp) {
              var obj = temp[i];
              ContryName += obj.charAt(0).toUpperCase() + obj.slice(1) + " ";
            }
          }
          ContryName = ContryName.substring(0, ContryName.length - 1);
        }
      }
      return ContryName;
    },
    getUserDetailsStripe() {
      window.scrollTo(0, 0);
      //this.isLoading = true;

      var getUserDetailsAPIURL =
        process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_GetUserDetailsStripe;
      getUserDetailsAPIURL = getUserDetailsAPIURL.replace("{UIMId}", this.userID);
      try {
        fetchData(getUserDetailsAPIURL, {
          headers: {
            Accept: "application/json",
          },
        })
          .then((response) => {
            if (response) {
              if (response.status == 200) {
                if (response.data) {
                  this.userDetailsStripe = response.data[0];

                  //if(this.userDetailsStripe["id"]){
                  //this.getSubscriptionListStripe(this.userDetailsStripe["id"]);
                  //}
                  if (this.userDetailsStripe.address) {
                    var Address_1 = "";
                    var Address_2 = "";
                    var City = "";
                    var State = "";
                    var ZipCode = "";
                    var Country = "";
                    if (this.userDetailsStripe.address["line1"]) {
                      Address_1 = this.userDetailsStripe.address["line1"];
                      this.txtAddress1 = this.userDetailsStripe.address["line1"];
                    }
                    else if(this.userDetailsStripe.address["line1"] == "" || this.userDetailsStripe.address["line1"] == null) {
                        this.addressBlank=true;
                    }
                    if (this.userDetailsStripe.address["line2"]) {
                      Address_2 = this.userDetailsStripe.address["line2"];
                      this.txtAddress2 = this.userDetailsStripe.address["line2"];
                    }
                    if (this.userDetailsStripe.address["city"]) {
                      City = this.userDetailsStripe.address["city"];
                      this.txtCity = this.userDetailsStripe.address["city"];
                    }

                    if (this.userDetailsStripe.address["postalCode"]) {
                      ZipCode = this.userDetailsStripe.address["postalCode"];
                      this.txtZipCode = this.userDetailsStripe.address["postalCode"];
                    }

                    if (this.userDetailsStripe.address["country"]) {
                      Country = this.getCountryName(
                        this.userDetailsStripe.address["country"]
                      );
                      this.txtCountry = Country;
                    }
                    else if(this.userDetailsStripe.address["country"] ==null){
                      this.txtCountry = "United States";
                      this.UsaState = true;
                        this.lblZipCode = "Zip Code";
                    }

                    if (this.userDetailsStripe.address["state"] != null) {
                      State = this.getStateName(
                        this.txtCountry,
                        this.userDetailsStripe.address["state"]
                      );
                      if (this.txtCountry == "United States") {
                        this.UsaState = true;
                        this.txtUsaState = State;
                        this.lblZipCode = "Zip Code";
                      } else if (this.txtCountry == "Canada") {
                        this.CanadaState = true;
                        this.txtCanadaState = State;
                        this.lblZipCode = "Zip / Postal Code";
                      } else {
                        this.OtherState = true;
                        this.txtOtherState = State;
                        this.lblZipCode = "Zip / Postal Code";
                      }
                    }
                    if (Address_1) {
                      this.Address =
                        Address_1 +
                        " " +
                        Address_2 +
                        " " +
                        City +
                        " " +
                        State +
                        ", " +
                        Country +
                        " " +
                        ZipCode;
                    } else {
                      this.Address = Country + " " + ZipCode;
                    }
                  }
                }
              } else {
                if (response?.response?.data?.Message) {
                  this.showErrorStateMsg(response.response.data.Message);
                } else {
                  this.showErrorStateMsg(response.message);
                }
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
        //.finally(() => (this.isLoading = false));
      } catch (ex) {
        console.log(ex.message);
      }
    },
    AddClassAddress(id) {
      try {
        setTimeout(() => {
          var element = document.getElementById(id);
          element.classList.add("subscription-active-color");
        }, 200);
      } catch (ex) {
        //
      }
    },
    AddClassProduct(id, className) {
      try {
        setTimeout(() => {
          var element = document.getElementById(id);
          element.classList.add(className);
        }, 200);
      } catch (ex) {
        //
      }
    },
    RemoveClassAddress(id) {
      try {
        var element = document.getElementById(id);
        element.classList.remove("subscription-active-color");
      } catch (ex) {
        //
      }
    },
    AddressClick() {
      this.AddressDisplay = false;
      this.EditAddress = true;
      if (this.IsUserInStripe) {
        setTimeout(() => {
          var element = document.getElementById("billingAddress");
          if(element != null && element.classList != null){
            element.classList.add("subscription-billing-address-heading");
          }
        }, 500);
        var State = "";
        if (this.userDetailsStripe.address["state"]) {
          State = this.getStateName(
            this.txtCountry,
            this.userDetailsStripe.address["state"]
          );
          if (this.txtCountry == "United States") {
            this.UsaState = true;
            this.txtUsaState = State;
          } else if (this.txtCountry == "Canada") {
            this.CanadaState = true;
            this.txtCanadaState = State;
          } else {
            this.OtherState = true;
            this.txtOtherState = State;
          }
        }
        this.CanadaStateError = false;
        this.OtherStateError = false;
        this.USAStateError = false;
        this.AddClassAddress("subscription-address-id");
      } else {
        this.AddressClick_Omaha();
      }
    },
    AddressClick_Omaha() {

      setTimeout(() => {
          var element = document.getElementById("billingAddress");
          if(element != null && element.classList != null){
            element.classList.add("subscription-billing-address-heading-hide-address2");
          }
        }, 500);
      var State = "";
      if (this.userDetails["State"]) {
        State = this.userDetails["State"];
        if (this.txtCountry == "USA") {
          this.UsaState = true;
          this.txtUsaState = State;
        } else if (this.txtCountry == "Canada") {
          this.CanadaState = true;
          this.txtCanadaState = State;
        } else {
          this.OtherState = true;
          this.txtOtherState = State;
        }
      }
      this.CanadaStateError = false;
      this.OtherStateError = false;
      this.USAStateError = false;
      this.AddClassAddress("subscription-address-id");
    },
    CancelAddress() {
      if (this.IsUserInStripe) {
        this.AddressDisplay = true;
        this.EditAddress = false;
        this.UsaState = false;
        this.CanadaState = false;
        this.OtherState = false;
        this.txtAddress2 = "";

        if (this.userDetailsStripe.address["line1"]) {
          this.txtAddress1 = this.userDetailsStripe.address["line1"];
        }
        if (this.userDetailsStripe.address["line2"]) {
          this.txtAddress2 = this.userDetailsStripe.address["line2"];
        }
        if (this.userDetailsStripe.address["city"]) {
          this.txtCity = this.userDetailsStripe.address["city"];
        }
        // if (this.userDetails["State"]) {
        //     State = this.userDetails["State"];
        // }
        if (this.userDetailsStripe.address["postalCode"]) {
          this.txtZipCode = this.userDetailsStripe.address["postalCode"];
        }

        if (this.userDetailsStripe.address["country"]) {
          //  Country = this.userDetails["Country"];
          this.txtCountry = this.getCountryName(
            this.userDetailsStripe.address["country"]
          );
        }
        else if(this.userDetailsStripe.address["country"] ==null){
            this.txtCountry = "United States";
            this.UsaState = true;
            this.lblZipCode = "Zip Code";
        }

        var State = "";
        if (this.userDetailsStripe.address["state"]) {
          State = this.getStateName(
            this.txtCountry,
            this.userDetailsStripe.address["state"]
          );
          if (this.txtCountry == "United States") {
            this.UsaState = true;
            this.txtUsaState = State;
          } else if (this.txtCountry == "Canada") {
            this.CanadaState = true;
            this.txtCanadaState = State;
          } else {
            this.OtherState = true;
            this.txtOtherState = State;
          }
        } else {
          if (this.txtCountry == "United States") {
            this.txtUsaState = State;
          } else if (this.txtCountry == "Canada") {
            this.txtCanadaState = State;
          } else {
            this.txtOtherState = State;
          }
        }
        this.CanadaStateError = false;
        this.OtherStateError = false;
        this.USAStateError = false;
        this.RemoveClassAddress("subscription-address-id");
      } else {
        this.CancelAddress_Omaha();
      }
    },
    CancelAddress_Omaha() {
      this.AddressDisplay = true;
      this.EditAddress = false;
      if (this.userDetails["Address_1"]) {
        this.txtAddress1 = this.userDetails["Address_1"];
      }
      if (this.userDetails["Address_2"]) {
        this.txtAddress2 = this.userDetails["Address_2"];
      }
      if (this.userDetails["City"]) {
        this.txtCity = this.userDetails["City"];
      }
      // if (this.userDetails["State"]) {
      //     State = this.userDetails["State"];
      // }
      if (this.userDetails["ZipCode"]) {
        this.txtZipCode = this.userDetails["ZipCode"];
      }

      if (this.userDetails["Country"]) {
        //  Country = this.userDetails["Country"];
        this.txtCountry = this.ChangeContryName(this.userDetails["Country"]);
      }
      var State = "";
      if (this.userDetails["State"]) {
        State = this.userDetails["State"];
        if (this.txtCountry == "USA") {
          this.UsaState = true;
          this.txtUsaState = State;
        } else if (this.txtCountry == "Canada") {
          this.CanadaState = true;
          this.txtCanadaState = State;
        } else {
          this.OtherState = true;
          this.txtOtherState = State;
        }
        this.UsaState = false;
        this.CanadaState = false;
        this.OtherState = false;
      } else {
        if (this.txtCountry == "USA") {
          this.txtUsaState = State;
        } else if (this.txtCountry == "Canada") {
          this.txtCanadaState = State;
        } else {
          this.txtOtherState = State;
        }
      }
      this.CanadaStateError = false;
      this.OtherStateError = false;
      this.USAStateError = false;
      this.RemoveClassAddress("subscription-address-id");
    },
    countryChange() {
      if (this.IsUserInStripe) {
        if (this.txtCountry) {
          this.UsaState = false;
          this.CanadaState = false;
          this.OtherState = false;
          this.txtUsaState = "";
          this.txtCanadaState = "";
          this.txtOtherState = "";
          if (this.txtCountry == "United States") {
            this.UsaState = true;
            this.lblZipCode = "Zip Code";
          } else if (this.txtCountry == "Canada") {
            this.CanadaState = true;
            this.lblZipCode = "Zip / Postal Code";
          } else {
            this.OtherState = true;
            this.lblZipCode = "Zip / Postal Code";
          }
        }
      } else {
        this.countryChange_Omaha();
      }
    },
    countryChange_Omaha() {
      if (this.txtCountry) {
        this.UsaState = false;
        this.CanadaState = false;
        this.OtherState = false;
        this.txtUsaState = "";
        this.txtCanadaState = "";
        this.txtOtherState = "";
        if (this.txtCountry == "USA") {
          this.UsaState = true;
          this.lblZipCode = "Zip Code";
        } else if (this.txtCountry == "Canada") {
          this.CanadaState = true;
          this.lblZipCode = "Zip / Postal Code";
        } else {
          this.OtherState = true;
          this.lblZipCode = "Zip / Postal Code";
        }
      }
    },
    getCountryName(code) {
      const country = this.lstCountry.find((item) => item.CountryCode == code);
      return country ? country.Country : "";
    },
    getStateName(Country, State) {
      if (Country == "United States") {
        const state = this.lstUsaState.find((item) => item.StateAbbr == State);
        return state ? state.StateName : "";
      } else if (Country == "Canada") {
        const state = this.lstCanadaState.find((item) => item.StateAbbr == State);
        return state ? state.StateName : "";
      } else {
        return State;
      }
    },
    SaveAddress() {
      if (this.IsUserInStripe) {
        this.SaveAddressStripe();
      } else {
        this.SaveAddress_Omaha();
      }
    },
    SaveAddressStripe() {
      var bValidate = true;
      if (this.txtAddress1.trim()) {
        this.Address1Error = false;
      } else {
        this.Address1Error = true;
      }

      if (this.txtCity.trim()) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }

      if (this.txtZipCode.trim()) {
        if (this.txtCountry == "United States") {
          if (this.txtZipCode.length == 5) {
            this.zipCodeError = false;
          } else {
            this.zipCodeError = true;
            this.txtZipCodeErrorMsg = "Zip code is not valid";
            //return false;
            bValidate = false;
          }
        } else if (this.txtCountry == "Canada") {
          // if (this.txtZipCode.length == 6) {
          //     this.zipCodeError = false;
          // } else {
          //     this.zipCodeError = true;
          //     this.txtZipCodeErrorMsg = "Zip / Postal code is not valid";
          //     return false;
          // }
          if (
            !/^[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{1}[ ]{0,1}[0-9]{1}[a-zA-Z]{1}[0-9]{1}/.test(
              this.txtZipCode.trim()
            )
          ) {
            this.zipCodeError = true;
            this.txtZipCodeErrorMsg = "Zip / Postal code is not valid";
            //return false;
            bValidate = false;
          } else {
            this.txtZipCode = this.txtZipCode.replace(/\s/g, "");
            this.txtZipCode = this.txtZipCode.replace(/.{3}/g, "$& ");
            this.txtZipCode = this.txtZipCode.trim();
            this.zipCodeError = false;
          }
        } else if (this.txtCountry != "Canada" && this.txtCountry != "United States") {
          if (this.txtZipCode.trim()) {
            this.zipCodeError = false;
          } else {
            this.zipCodeError = true;
            this.txtZipCodeErrorMsg = "Zip / Postal code is not valid";
            //return false;
            bValidate = false;
          }
        }
      } else {
        this.zipCodeError = true;
        //this.txtZipCodeErrorMsg = "Please enter a zip code";
        if (this.txtCountry == "United States") {
          this.txtZipCodeErrorMsg = "Zip Code is required";
        } else {
          this.txtZipCodeErrorMsg = "Zip / Postal code is required";
        }
        //return false;
        bValidate = false;
      }

      if (this.txtCountry) {
        this.CountryError = false;
      } else {
        this.CountryError = true;
        //return false;
        bValidate = false;
      }

      if (this.txtCountry) {
        if (this.txtCountry == "United States") {
          this.SaveStateValue = this.txtUsaState;
          if (this.txtUsaState) {
            this.USAStateError = false;
          } else {
            this.USAStateError = true;
            //return false;
            bValidate = false;
          }
        } else if (this.txtCountry == "Canada") {
          this.SaveStateValue = this.txtCanadaState;
          // if (this.txtCanadaState) {
          //     this.CanadaStateError = false;
          // } else {
          //     this.CanadaStateError = true;
          //     return false;
          // }
        } else {
          this.SaveStateValue = this.txtOtherState.trim();
        }
      }
      if(bValidate){
        if (
          this.txtCountry.trim() &&
          this.txtAddress1.trim() &&
          this.txtZipCode.trim() &&
          this.txtCity.trim()
        ) {
          this.CommonSaveStripe();
        }
      }
      else{
        return false;
      }
    },
    SaveAddress_Omaha() {
      if (this.txtAddress1.trim()) {
        this.Address1Error = false;
      } else {
        this.Address1Error = true;
      }

      // if (this.txtAddress2) {
      //     this.Address2Error = false;
      // } else {
      //     this.Address2Error = true;
      // }

      if (this.txtCity.trim()) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }

      if (this.txtZipCode.trim()) {
        if (this.txtCountry.toUpperCase() == "USA") {
          if (this.txtZipCode.length == 5) {
            this.zipCodeError = false;
          } else {
            this.zipCodeError = true;
            this.txtZipCodeErrorMsg = "Zip code is not valid";
            return false;
          }
        } else if (this.txtCountry.toUpperCase() == "CANADA") {
          // if (this.txtZipCode.length == 6) {
          //     this.zipCodeError = false;
          // } else {
          //     this.zipCodeError = true;
          //     this.txtZipCodeErrorMsg = "Zip / Postal code is not valid";
          //     return false;
          // }
          if (
            !/^[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{1}[ ]{0,1}[0-9]{1}[a-zA-Z]{1}[0-9]{1}/.test(
              this.txtZipCode.trim()
            )
          ) {
            this.zipCodeError = true;
            this.txtZipCodeErrorMsg = "Zip / Postal code is not valid";
            return false;
          } else {
            this.txtZipCode = this.txtZipCode.replace(/\s/g, "");
            this.txtZipCode = this.txtZipCode.replace(/.{3}/g, "$& ");
            this.txtZipCode = this.txtZipCode.trim();
            this.zipCodeError = false;
          }
        } else if (
          this.txtCountry.toUpperCase() != "CANADA" &&
          this.txtCountry.toUpperCase() != "USA"
        ) {
          if (this.txtZipCode.trim()) {
            this.zipCodeError = false;
          } else {
            this.zipCodeError = true;
            this.txtZipCodeErrorMsg = "Zip / Postal code is not valid";
            return false;
          }
        }
      } else {
        this.zipCodeError = true;
        //this.txtZipCodeErrorMsg = "Please enter a zip code";
        if (this.txtCountry.toUpperCase() == "USA") {
          this.txtZipCodeErrorMsg = "Zip Code is required";
        } else {
          this.txtZipCodeErrorMsg = "Zip / Postal Code is required";
        }
        return false;
      }

      if (this.txtCountry) {
        this.CountryError = false;
      } else {
        this.CountryError = true;
        return false;
      }

      if (this.txtCountry) {
        if (this.txtCountry == "USA") {
          this.SaveStateValue = this.txtUsaState;
          if (this.txtUsaState) {
            this.USAStateError = false;
          } else {
            this.USAStateError = true;
            return false;
          }
        } else if (this.txtCountry == "Canada") {
          this.SaveStateValue = this.txtCanadaState;
          // if (this.txtCanadaState) {
          //     this.CanadaStateError = false;
          // } else {
          //     this.CanadaStateError = true;
          //     return false;
          // }
        } else {
          this.SaveStateValue = this.txtOtherState.trim();
          // if (this.txtOtherState.trim()) {
          //     this.OtherStateError = false;
          // } else {
          //     this.OtherStateError = true;
          //     return false;
          // }
        }
      }
      // var state="";

      if (
        this.txtCountry.trim() &&
        this.txtAddress1.trim() &&
        this.txtZipCode.trim() &&
        this.txtCity.trim()
      ) {
        this.CommonSave_omaha("Address");
      }
    },
    async CommonSaveStripe() {
      var CustomerId = "";
      if (this.userDetailsStripe["id"]) {
        CustomerId = this.userDetailsStripe["id"];
      }

      this.btnAddressSave = false;
      this.btnAddressLoading = true;

      var CountryCode = this.getCountryCode(this.txtCountry.trim());

      if (this.txtCountry) {
        if (this.txtCountry == "United States") {
          this.SaveStateValue = this.getStateCode(
            this.txtCountry.trim(),
            this.txtUsaState.trim()
          );
        } else if (this.txtCountry == "Canada") {
          this.SaveStateValue = this.getStateCode(
            this.txtCountry.trim(),
            this.txtCanadaState.trim()
          );
        } else {
          this.SaveStateValue = this.txtOtherState.trim();
        }
      }
      // const address = {
      //     line1:this.txtAddress1.trim(),
      //     line2:this.txtAddress2.trim(),
      //     city:this.txtCity.trim(),
      //     state:this.SaveStateValue.trim(),
      //     country:CountryCode.trim(),
      //     postalCode:this.txtZipCode.trim()
      // };

      var UpdateCustomerCommand = {};
      UpdateCustomerCommand.CustomerId = CustomerId;
      UpdateCustomerCommand.AddressLine1 = this.txtAddress1.trim();
      UpdateCustomerCommand.AddressLine2 = this.txtAddress2.trim();
      UpdateCustomerCommand.City = this.txtCity.trim();
      UpdateCustomerCommand.State = this.SaveStateValue.trim();
      UpdateCustomerCommand.Country = CountryCode.trim();
      UpdateCustomerCommand.PostalCode = this.txtZipCode.trim();

      try {

        // taxonomo tax update here. 

        let taxMSI, taxMDI, taxMFI, taxMEI;

        // Prepare the API URL
        let Url = this.ValidateAddressAndCalculateTax;

        // Replace placeholder values in the URL
        Url = Url.replace("{city}", this.txtCity.trim());
        Url = Url.replace("{region}", this.SaveStateValue.trim())
        Url = Url.replace("{customid}", CustomerId); // Stripe Customer ID
        Url = Url.replace(
          "{buyername}",
          this.userDetailsStripe["name"]
        );
        Url = Url.replace("{postalcode}", this.txtZipCode.trim());
        Url = Url.replace("{streetname}", encodeURIComponent(this.txtAddress1.trim()));
        Url = Url.replace("{currencycode}", "USD");
        Url = Url.replace("{billingcountrycode}", "US");
        // Loop through the subscription types and calculate tax for each
          const calculateTax = async (price, subscriptionType) => {
            let taxUrl = Url.replace("{amount}", price);
            try {
              const response = await postData(taxUrl);
              if (response && response.status == 200 && response.data) {
                let taxAmount = response.data.TaxAmount;

                let responseMessage = response.data.ResponseMessage;

                if (
                  responseMessage ==
                  "The entered Address is Wrong, please add a valid address!"
                ) {
                  this.isValidAddress = false;
                } else if (responseMessage == "Tax calculation successful") {
                  this.isValidAddress = true;
                  this.isValidAddressForCreatingUserInstripe = true;
                }

                switch (subscriptionType) {
                  case "MSI": {
                    const taxMSI = taxAmount;
                    this.taxAmountForMSI = taxMSI;

                    const msiCalculatedTaxAmount = {
                      taxamount: this.taxAmountForMSI,
                    };

                    this.setProductTaxInLocalStorage(
                      msiCalculatedTaxAmount,
                      "MSITaxAmount"
                    );

                    break;
                  }

                  case "MDI": {
                    const taxMDI = taxAmount; // Declare taxMDI properly
                    this.taxAmountForMDI = taxMDI;
                    const mdiCalculatedTaxAmount = {
                      taxamount: this.taxAmountForMDI,
                    };

                    // Fix the typo in the localStorage key
                    this.setProductTaxInLocalStorage(
                      mdiCalculatedTaxAmount,
                      "MDITaxAmount"
                    );

                    break;
                  }

                  case "MFI": {
                    const taxMFI = taxAmount; // Declare taxMFI properly
                    this.taxAmountForMFI = taxMFI;
                    const mfiCalculatedTaxAmount = {
                      taxamount: this.taxAmountForMFI,
                    };

                    // Fix the typo in the localStorage key
                    this.setProductTaxInLocalStorage(
                      mfiCalculatedTaxAmount,
                      "MFITaxAmount"
                    );

                    break;
                  }

                  case "MEI": {
                    const taxMEI = taxAmount; // Declare taxMEI properly
                    this.taxAmountForMEI = taxMEI;
                    const meiCalculatedTaxAmount = {
                      taxamount: this.taxAmountForMEI,
                    };

                    // Fix the typo in the localStorage key
                    this.setProductTaxInLocalStorage(
                      meiCalculatedTaxAmount,
                      "MEITaxAmount"
                    );

                    break;
                  }

                  default:
                    break;
                }
              }
              else{
                this.isValidAddress = false;
              }
            } catch (error) {
              if (process.env.NODE_ENV == 'development') {
                console.error(`Error calculating tax for ${subscriptionType}:`, error);
                console.log("Taxes : " + taxMDI + taxMEI + taxMFI + taxMSI);
              }
              this.isValidAddress = false;
            }
          };

          // Calculate tax for each subscription
        for (let i = 0; i < this.lstSubscription.length; i++) {
          if (this.lstSubscription[i].ProductCode === "NF00000001") {
            await calculateTax(this.lstSubscription[i].TotAmount, "MFI");
          }
            else if (this.lstSubscription[i].ProductCode == "NM00000001") {
              await calculateTax(this.lstSubscription[i].TotAmount, "MSI");
          } else if (this.lstSubscription[i].ProductCode == "NDI0000001") {
            await calculateTax(this.lstSubscription[i].TotAmount, "MDI");
          } else if (this.lstSubscription[i].ProductCode == "NET0000001") {
            await calculateTax(this.lstSubscription[i].TotAmount, "MEI");
          }
        }

        var UserDataUrl =
          process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_UpdateUserStripe;
        //var UserDataUrl = "https://localhost:50377/update-customer";
        postData(UserDataUrl, UpdateCustomerCommand)
          .then((response) => {
            if (response) {
              window.scrollTo(0, 0);
              if (response.status == 200) {
                if (response.data) {
                  //var result = response.data;
                  this.showStateMsg(response.data.message);

                  this.txtUsaState = "";
                  this.txtCanadaState = "";
                  this.txtOtherState = "";
                  this.UsaState = false;
                  this.CanadaState = false;
                  this.OtherState = false;
                  this.txtAddress1 = "";
                  this.txtAddress2 = "";
                  this.txtCity = "";
                  this.txtZipCode = "";
                  this.txtCountry = "";
                  this.SaveStateValue = "";

                  this.btnAddressLoading = false;
                  this.btnAddressSave = true;

                  this.AddressDisplay = true;
                  this.EditAddress = false;

                  this.getUserDetailsStripe();
                }
              } else {
                if (response?.response?.data?.Message) {
                  this.showErrorStateMsg(response.response.data.Message);
                } else {
                  this.showErrorStateMsg(response.message);
                }

                this.btnAddressSave = true;
                this.btnAddressLoading = false;
              }
            }
          })
          .catch((error) => {
            console.log("catch Error =" + error);
          })
          .finally();
      } catch (ex) {
        console.log(ex.message);
      }
    },
    setProductTaxInLocalStorage(data, productSubscriptionTaxAmount) {
      localStorage.setItem(productSubscriptionTaxAmount, JSON.stringify(data));
    },
    CommonSave_omaha() {
      var omahaCustomerID = "";
      if (this.userDetails["CustomerID"]) {
        omahaCustomerID = this.userDetails["CustomerID"];
      }

      this.btnAddressSave = false;
      this.btnAddressLoading = true;

      if (this.txtCountry) {
        if (this.txtCountry == "USA") {
          this.SaveStateValue = this.txtUsaState;
        } else if (this.txtCountry == "Canada") {
          this.SaveStateValue = this.txtCanadaState;
        } else {
          this.SaveStateValue = this.txtOtherState;
        }
      }

      var UpdateUserData = {};
      UpdateUserData.companyId = "";
      UpdateUserData.companyName = "";
      UpdateUserData.jobTitle = "";
      UpdateUserData.branch = "";
      UpdateUserData.firstName = this.userDetails["FirstName"];
      UpdateUserData.midInitial = "";
      UpdateUserData.lastName = this.userDetails["LastName"];
      UpdateUserData.salutation = "";
      UpdateUserData.address1 = this.txtAddress1.trim();
      UpdateUserData.address2 = this.txtAddress2.trim();
      UpdateUserData.city = this.txtCity.trim();
      UpdateUserData.state = this.SaveStateValue.trim();
      UpdateUserData.zipCode = this.txtZipCode.trim();
      UpdateUserData.region = "";
      UpdateUserData.country = this.txtCountry;
      UpdateUserData.phoneHome = this.userDetails["Dphone"];
      UpdateUserData.phoneMobile = this.userDetails["Mphone"];
      UpdateUserData.pager = "";
      UpdateUserData.fax = "";
      UpdateUserData.email = this.userDetails["Email"];
      UpdateUserData.login = "";
      UpdateUserData.password = "";
      UpdateUserData.chkPhoneCall = this.chkPhoneCall;
      UpdateUserData.userID = this.userID;
      UpdateUserData.changeEmailId = false;

      var EditUserCommand = {};
      EditUserCommand.omahaCustomerID = omahaCustomerID;
      EditUserCommand.updateData = UpdateUserData;
      try {
        var UserDataUrl = process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_UpdateUser;
        //"https://localhost:50377/update-user"; //process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_UpdateUser;
        putData(UserDataUrl, EditUserCommand)
          .then((response) => {
            if (response) {
              window.scrollTo(0, 0);
              if (response.status == 200) {
                if (response.data) {
                  var result = response.data;
                  if (result) {
                    if (result.StatusCode == 200) {
                      //this.showSuccessMsg(result.ResponseMessage);
                      this.showStateMsg(result.ResponseMessage);

                      this.txtUsaState = "";
                      this.txtCanadaState = "";
                      this.txtOtherState = "";
                      this.UsaState = false;
                      this.CanadaState = false;
                      this.OtherState = false;
                      this.txtAddress1 = "";
                      this.txtAddress2 = "";
                      this.txtCity = "";
                      this.txtZipCode = "";
                      this.txtCountry = "";
                      this.SaveStateValue = "";
                      this.btnAddressLoading = false;
                      this.btnAddressSave = true;
                      this.AddressDisplay = true;
                      this.EditAddress = false;
                      this.chkPhoneCall = false;

                      this.getUserDetails_Omaha();
                    } else {
                      this.showErrorStateMsg(result.ResponseMessage);
                      this.btnAddressLoading = false;
                      this.btnAddressSave = true;
                    }
                  }
                }
              }
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally();
      } catch (ex) {
        console.log(ex.message);
      }
    },
    getCountryCode(Name) {
      const country = this.lstCountry.find((item) => item.Country == Name);
      return country ? country.CountryCode : "";
    },
    getStateCode(Country, State) {
      if (Country == "United States") {
        const state = this.lstUsaState.find((item) => item.StateName == State);
        return state ? state.StateAbbr : "";
      } else if (Country == "Canada") {
        const state = this.lstCanadaState.find((item) => item.StateName == State);
        return state ? state.StateAbbr : "";
      } else {
        return State;
      }
    },
    showStateMsg(str) {
      this.$store.state.product.lstAlertMsg = [];
      this.$store.state.product.lstAlertMsg.push(str);

      this.$store.state.product.SuccessAlert = true;
      this.$store.state.product.ErrorAlert = false;
      setTimeout(() => {
        this.$store.state.product.SuccessAlert = false;
      }, 5000);
    },
    showErrorStateMsg(str) {
      this.$store.state.product.lstAlertMsg = [];
      this.$store.state.product.lstAlertMsg.push(str);

      this.$store.state.product.SuccessAlert = false;
      this.$store.state.product.ErrorAlert = true;
      setTimeout(() => {
        this.$store.state.product.ErrorAlert = false;
      }, 5000);
    },
    getPhoneCallValue(customerId) {
      var GetPhoneCallUrl =
        process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_GetPhoneCall;
      GetPhoneCallUrl = GetPhoneCallUrl.replace("{customerId}", customerId);

      try {
        fetchData(GetPhoneCallUrl)
          .then((response) => {
            if (response) {
              if (response.status == 200) {
                if (response.data) {
                  if (response.data.PhoneCallCheckbox) {
                    this.chkPhoneCall = true;
                  } else {
                    this.chkPhoneCall = false;
                  }
                }
              }
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally();
      } catch (ex) {
        console.log(ex.message);
      }
    },
    async getUserDetails_Omaha_Stripe() {
      var Omaha_Response = await this.getUserDetails_Omaha_CustomerId();
      var OmahaSubscriptionResponse;
      if (Omaha_Response) {
        if (Omaha_Response["CustomerID"]) {
          var CustomerID_Omaha = Omaha_Response["CustomerID"];
          OmahaSubscriptionResponse = await this.getSubscriptionList_Omaha(
            CustomerID_Omaha
          );
        }
      }

      var Stripe_Response = await this.getUserDetails_Stripe_CustomerId();
      var StripeSubscriptionResponse;
      if (Stripe_Response) {
        if (Stripe_Response["id"]) {
          var CustomerID_Stripe = Stripe_Response["id"];
          StripeSubscriptionResponse = await this.getSubscriptionList_Stripe(
            CustomerID_Stripe
          );
        }
      }

      this.MergeApiResponse_Omaha_Stripe(
        OmahaSubscriptionResponse,
        StripeSubscriptionResponse
      );
    },
    async getUserDetails_Omaha_CustomerId() {
      var getUserDetailsAPIURL =
        process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_GetUserDetails;
      getUserDetailsAPIURL = getUserDetailsAPIURL.replace("{userId}", this.userID);
      try {
        const response = await fetchData(getUserDetailsAPIURL, {
          headers: {
            Accept: "application/json",
          },
        });
        if (response && response.status === 200 && response.data) {
          const result = response.data;
          return result;
        }
      } catch (ex) {
        console.log(ex.message);
      }
    },
    async getUserDetails_Stripe_CustomerId() {
      var getUserDetailsAPIURL =
        process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_GetUserDetailsStripe;
      getUserDetailsAPIURL = getUserDetailsAPIURL.replace("{UIMId}", this.userID);
      try {
        const response = await fetchData(getUserDetailsAPIURL, {
          headers: {
            Accept: "application/json",
          },
        });
        if (response && response.status === 200 && response.data) {
          const result = response.data[0];
          this.stripeIdForCC = result.id;
          this.GetStripeCreditCardDetails();
          //console.log("User Details : " + JSON.stringify(result.id));
          return result;
        }
      } catch (ex) {
        console.log(ex.message);
      }
    },

    async getSubscriptionList_Stripe(customerId) {
      //this.isLoading = true;
      var GetSubscriptionUrl =
        process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_SubscriptionListStripeUrl;
      GetSubscriptionUrl = GetSubscriptionUrl.replace("{customerId}", customerId);

      try {
        const response = await fetchData(GetSubscriptionUrl, {
          headers: {
            Accept: "application/json",
          },
        });
        if (response && response.status === 200 && response.data) {
          const result = response.data;
          return result;
        }
      } catch (ex) {
        console.log(ex.message);
      }
    },

    MergeApiResponse_Omaha_Stripe(OmahaSubscriptionResponse, StripeSubscriptionResponse) {
      var MFI_Omaha = [];
      var MSI_Omaha = [];
      var MDI_Omaha = [];
      var MEI_Omaha = [];

      var MFI_Stripe = [];
      var MSI_Stripe = [];
      var MDI_Stripe = [];
      var MEI_Stripe = [];

      if (OmahaSubscriptionResponse) {
        var responseFilter_Omaha = OmahaSubscriptionResponse;
        MFI_Omaha = responseFilter_Omaha.filter(function (el) {
          return el["ProductCode"] == "NF00000001" && el["TempStatus"] == "AS";
        });
        MSI_Omaha = responseFilter_Omaha.filter(function (el) {
          return el["ProductCode"] == "NM00000001" && el["TempStatus"] == "AS";
        });
        MDI_Omaha = responseFilter_Omaha.filter(function (el) {
          return el["ProductCode"] == "NDI0000001" && el["TempStatus"] == "AS";
        });
        MEI_Omaha = responseFilter_Omaha.filter(function (el) {
          return el["ProductCode"] == "NET0000001" && el["TempStatus"] == "AS";
        });
      }

      if (StripeSubscriptionResponse) {
        var responseFilter_Stripe = StripeSubscriptionResponse;
        MFI_Stripe = responseFilter_Stripe.filter(function (el) {
          return el["productName"] == "FundInvestor" && el["status"] == "active";
        });

        MSI_Stripe = responseFilter_Stripe.filter(function (el) {
          return el["productName"] == "StockInvestor" && el["status"] == "active";
        });

        MDI_Stripe = responseFilter_Stripe.filter(function (el) {
          return el["productName"] == "DividendInvestor" && el["status"] == "active";
        });

        MEI_Stripe = responseFilter_Stripe.filter(function (el) {
          return el["productName"] == "ETFInvestor" && el["status"] == "active";
        });
      }
      this.showErrorCustomerMsg(StripeSubscriptionResponse);
      if (OmahaSubscriptionResponse) {
        if (MFI_Omaha.length > 0) {
          this.PurchaseAppendArray_Omaha(this.MFIProductAccess, MFI_Omaha);
        }

        if (MFI_Stripe.length == 0) {
          if (MFI_Omaha.length == 0) {
            this.DigitalAppendArray_Omaha(this.MFIProductAccess, "NF00000001");
          }
        }
      }

      if (StripeSubscriptionResponse) {
        if (MFI_Stripe.length > 0) {
          this.PurchaseAppendArray_Stripe(
            MFI_Stripe,
            "NF00000001",
            this.MFIProductAccess
          );
        }
      }

      if (OmahaSubscriptionResponse) {
        if (MSI_Omaha.length > 0) {
          this.PurchaseAppendArray_Omaha(this.MSIProductAccess, MSI_Omaha);
        }

        if (MSI_Stripe.length == 0) {
          if (MSI_Omaha.length == 0) {
            this.DigitalAppendArray_Omaha(this.MSIProductAccess, "NM00000001");
          }
        }
      }

      // Stripe
      if (StripeSubscriptionResponse) {
        if (MSI_Stripe.length > 0) {
          this.PurchaseAppendArray_Stripe(
            MSI_Stripe,
            "NM00000001",
            this.MSIProductAccess
          );
        }
      }

      if (OmahaSubscriptionResponse) {
        if (MDI_Omaha.length > 0) {
          this.PurchaseAppendArray_Omaha(this.MDIProductAccess, MDI_Omaha);
        }
        if (MDI_Stripe.length == 0) {
          if (MDI_Omaha.length == 0) {
            this.DigitalAppendArray_Omaha(this.MDIProductAccess, "NDI0000001");
          }
        }
      }

      // Stripe
      if (StripeSubscriptionResponse) {
        if (MDI_Stripe.length > 0) {
          this.PurchaseAppendArray_Stripe(
            MDI_Stripe,
            "NDI0000001",
            this.MDIProductAccess
          );
        }
      }

      if (OmahaSubscriptionResponse) {
        if (MEI_Omaha.length > 0) {
          this.PurchaseAppendArray_Omaha(this.MEIProductAccess, MEI_Omaha);
        }
        if (MEI_Stripe.length == 0) {
          if (MEI_Omaha.length == 0) {
            this.DigitalAppendArray_Omaha(this.MEIProductAccess, "NET0000001");
          }
        }
      }
      // Stripe
      if (StripeSubscriptionResponse) {
        if (MEI_Stripe.length > 0) {
          this.PurchaseAppendArray_Stripe(
            MEI_Stripe,
            "NET0000001",
            this.MEIProductAccess
          );
        }
      }

      if (
        !this.MEIProductAccess &&
        !this.MDIProductAccess &&
        !this.MSIProductAccess &&
        !this.MFIProductAccess
      ) {
        this.NoActiveSubscription = true;
      } else {
        this.NoActiveSubscription = false;
      }

      this.isLoading = false;

      this.AddressDisplay = true;
      this.billInfo = true;

      if (this.stripeIdForCC != "") {
        this.ifPaymentMethod = true;
      }

      if(this.IsUserInStripe){
        setTimeout(() => {
              var element = document.getElementById("subscription-address-display");
              if(element != null && element.classList != null){
                  element.classList.add("subscription-address-custom-css");
              }
        }, 1000);
      }
    },
    PurchaseAppendArray_Omaha(ProductAccess, Omaha) {
      if (ProductAccess) {
        var ProductCode = "";
        var TotAmount = "";
        var EndDate = "";
        var Term = "";
        var LastPaymentDate = "";
        var ProductTerm = "";

        if (Omaha[0]["ProductCode"]) {
          ProductCode = Omaha[0]["ProductCode"];
        }
        if (Omaha[0]["TotAmount"]) {
          TotAmount = Omaha[0]["TotAmount"];
        }
        if (Omaha[0]["EndDate"]) {
          EndDate = Omaha[0]["EndDate"];
          //if (EndDate) {
          //  NextPaymentDate = this.addOneDay(EndDate);
          //}
        }
        if (Omaha[0]["Term"]) {
          Term = Omaha[0]["Term"];
        }
        if (Omaha[0]["LastPaymentDate"]) {
          LastPaymentDate = this.formatDate(Omaha[0]["LastPaymentDate"]);
        } else {
          LastPaymentDate = this.formatDate(Omaha[0]["StartDate"]);
        }

        if (ProductCode == "NF00000001") {
          ProductTerm = "FundInvestor";
        } else if (ProductCode == "NM00000001") {
          ProductTerm = "StockInvestor";
        } else if (ProductCode == "NDI0000001") {
          ProductTerm = "DividendInvestor";
        } else if (ProductCode == "NET0000001") {
          ProductTerm = "ETFInvestor";
        }

        this.lstSubscription.push({
          ProductCode: ProductCode,
          TotAmount: TotAmount,
          Term: ProductTerm + " Term",
          EndDate: EndDate,
          CurrentMonth: this.checkCurrentMonth(EndDate),
          ProductTerm: Term,
          IsTrial: Omaha[0]["IsTrial"],
          DigitalAccess: false,
          IsUserInStripe: false,
          NextPaymentDate: this.formatDate(EndDate),
          LastPaymentDate: LastPaymentDate,
        });
      }
    },
    DigitalAppendArray_Omaha(ProductAccess, ProductCode) {
      if (ProductAccess) {
        this.lstSubscription.push({
          ProductCode: ProductCode,
          TotAmount: "",
          Term: "",
          EndDate: "",
          CurrentMonth: "",
          ProductTerm: "",
          DigitalAccess: true,
          IsUserInStripe: false,
        });
      }
    },
    PurchaseAppendArray_Stripe(Stripe, ProductCode, ProductAccess) {
      if (ProductAccess) {
        var LastPaymentDate = "";
        var NextPaymentDate = "";
        var SubscriptionEndDate = "";
        var Term = "";
        var NextAmount = "";
        var NextDiscountedPrice = "";
        var SubscriptionID = ""; 
        if (Stripe[0]["lastPaymentDate"]) {
          LastPaymentDate = this.formatDatestripe(Stripe[0]["lastPaymentDate"]);
        }

        if (Stripe[0]["nextPaymentDate"]) {
          NextPaymentDate = this.formatDatestripe(Stripe[0]["nextPaymentDate"]);
        }

        if (Stripe[0]["subscriptionEndDate"]) {
          SubscriptionEndDate = Stripe[0]["subscriptionEndDate"];
        }

        if (Stripe[0]["nextAmount"]) {
          NextAmount = parseFloat(Stripe[0]["nextAmount"]).toFixed(2);
        }

        if (Stripe[0]["nextDiscountedPrice"]) {
          NextDiscountedPrice = parseFloat(Stripe[0]["nextDiscountedPrice"]).toFixed(2);
        }

        //if (NextAmount && NextDiscountedPrice) {
        //  NextAmount = (NextAmount - NextDiscountedPrice).toFixed(2);
        //}

        if (ProductCode == "NF00000001") {
          Term = "FundInvestor";
        } else if (ProductCode == "NM00000001") {
          Term = "StockInvestor";
        } else if (ProductCode == "NDI0000001") {
          Term = "DividendInvestor";
        } else if (ProductCode == "NET0000001") {
          Term = "ETFInvestor";
        }

        if (Stripe[0]["lastPaymentDate"]) {
          SubscriptionID = Stripe[0]["subscriptionId"];
        }

        this.lstSubscription.push({
          ProductCode: ProductCode,
          TotAmount: Stripe[0]?.lastAmount || "",
          Term: Term + " Term",
          EndDate: LastPaymentDate,
          CurrentMonth: this.checkCurrentMonth_Stripe(SubscriptionEndDate),
          ProductTerm: Stripe[0]?.term || "",
          IsTrial: "",
          DigitalAccess: false,
          IsUserInStripe: true,
          NextPaymentDate: NextPaymentDate,
          NextPaymentAmount: NextAmount,
          NextDiscountedPrice: NextDiscountedPrice,
          subscriptionEndDate: SubscriptionEndDate,
          SubscriptionID:SubscriptionID,
          InvoicePdf:Stripe[0]?.invoicePdf || "",
          LastDiscountedPrice: Stripe[0]?.lastDiscountedPrice || 0,
          InvoiceStatus:Stripe[0]?.invoiceStatus || ""
        });
      }
    },
    formatDatestripe(strDate) {
      if (strDate) {
        var temp = strDate.split("-");
        var date = "";
        var Month = "";
        var year = "";
        if (temp) {
          if (temp[1]) {
            Month = temp[1];
          }
          if (temp[2]) {
            date = temp[2];
          }
          if (temp[0]) {
            year = temp[0];
          }
        }
        var str = "";
        if (Month == "01") {
          str = "January";
        } else if (Month == "02") {
          str = "February";
        } else if (Month == "03") {
          str = "March";
        } else if (Month == "04") {
          str = "April";
        } else if (Month == "05") {
          str = "May";
        } else if (Month == "06") {
          str = "June";
        } else if (Month == "07") {
          str = "July";
        } else if (Month == "08") {
          str = "August";
        } else if (Month == "09") {
          str = "September";
        } else if (Month == "10") {
          str = "October";
        } else if (Month == "11") {
          str = "November";
        } else if (Month == "12") {
          str = "December";
        }
        return str + ". " + date + ", " + year;
      }
      return "";
    },
    /** CANCEL SUBSCRIPTION METHODS STARTS */
    populateCancelSubscriptionPropObject(term, subscriptionId) {
      this.cancelSubscriptionPropObject.modalStatus = !this.cancelSubscriptionPropObject
        .modalStatus;
      this.cancelSubscriptionPropObject.product = term;
      this.cancelSubscriptionPropObject.userID = this.userID;
      this.cancelSubscriptionPropObject.StripeSubscriptionId = subscriptionId;
    },
    resetCancelSubscriptionModalStatus(toggleValue) {
      this.cancelSubscriptionPropObject.modalStatus = toggleValue;
    },
    subscriptionCancellationStatus(isSubscriptionCancelled) {
      if (isSubscriptionCancelled) {
        this.isLoading = true;

        setTimeout(() => {
        //A temporary solution to refresh the page, preventing the user from accessing the product after cancellation.
          window.location.href = window.location.pathname;
        ///////////////////////////////////////////////
          this.$store.state.product.SuccessAlert = false;
          this.$store.state.product.ErrorAlert = false;
          this.$store.state.product.lstAlertMsg.length = 0;
        }, 4000);
      }else{
        this.lstSubscription.length = 0;
        this.getUserDetails_Omaha_Stripe();
      }
    },
    /** CANCEL SUBSCRIPTION METHODS ENDS */

    checkCurrentMonth_Stripe(EndDate) {
      var bValid = false;

      if (EndDate) {
        var temp = EndDate.split("-");
        var Month = "";
        var year = "";
        var day = "";
        if (temp) {
          if (temp[0]) {
            if (parseInt(temp[1]) < 10) {
              Month = "0" + temp[1];
            } else {
              Month = temp[1];
            }
          }
          if (temp[0]) {
            year = temp[0];
          }
          if (temp[2]) {
            if (parseInt(temp[2]) < 10) {
              day = "0" + temp[2];
            } else {
              day = temp[2];
            }
          }
          EndDate = Month + "/" + day + "/" + year;
        }
      }

      const today = new Date();
      const yyyy = today.getFullYear();
      let mm = today.getMonth() + 1; // Months start at 0!
      let dd = today.getDate();

      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;

      const formattedToday = mm + "/" + dd + "/" + yyyy;

      var date1 = new Date(formattedToday);
      var date2 = new Date(EndDate);

      var Difference_In_Time = date2.getTime() - date1.getTime();

      var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
      if (Difference_In_Days <= 30) {
        bValid = true;
      } else {
        bValid = false;
      }
      return bValid;
    },
    addOneDay(dateStr) {
      let date = new Date(dateStr);

      date.setDate(date.getDate() + 1);

      let month = date.getMonth() + 1;
      let day = date.getDate();
      let year = date.getFullYear();

      return `${month}/${day}/${year}`;
    },

    GetStripeCreditCardDetails() {
      // Construct the API URL
      var GetCreditCardDetailsFromStripe =
        process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_GET_CREDIT_CARD_DETAILS;
      const url = GetCreditCardDetailsFromStripe.replace(
        "{customerId}",
        this.stripeIdForCC
      );
      /*
      const url = GetCreditCardDetailsFromStripe.replace(
        "{customerId}",
        "cus_RqM6Qv94HBrMwN"
      );
      */

      //console.log("Fetching data from:", url);

      // Call fetchData
      fetchData(url, {
        headers: {
          Accept: "application/json",
        },
      })
        .then((response) => {
          // console.log("API response received:", response.data[0]);

          if (Array.isArray(response.data)) {
            // Process each credit card and store them in the arrays
            if (response.data[0]) {
              this.firstCreditCard.push(response.data[0]);
              //console.log("First Credit Card added:", this.firstCreditCard);
            }

            if (response.data[1]) {
              this.secondCreditCard.push(response.data[1]);
              this.IsSecondCardPresent;
              this.isSecondCreditCardBorderRequired = true;
              // console.log("Second Credit Card added:", this.secondCreditCard);
            }
          } else {
            console.log("Response is not an array:", response);
          }

          if (this.firstCreditCard[0].isPrimary == true) {
            this.ifFirstCreditCardPrimary = true;
            this.firstCCSetPrimaryButton = false;
            this.secondCCSetPrimaryButton = true;
          } else if (this.secondCreditCard[0].isPrimary == true) {
            this.ifsecondCreditCardPrimary = true;
            this.firstCCSetPrimaryButton = true;
            this.secondCCSetPrimaryButton = false;
          } else {
            this.ifFirstCreditCardPrimary = false;
            this.ifsecondCreditCardPrimary = false;
          }
        })
        .catch((error) => {
          console.error("Error fetching credit card details:", error);
        });
    },

    FirstCreditCardEditOperation() {
      if (this.secondCreditCard.length > 0) {
        this.addNewPaymentMethodButton = false;
        this.isEditButtonClicked = true;
        this.isSecondCreditCardBorderRequired = true;
        this.editbutton = false;
        //this.editafterapply = true;
        //this.editafterapplysecond = true;
      } else {
        //this.editafterapplysecond = false;
        this.isEditButtonClicked = true;
        this.isSecondCreditCardBorderRequired = false;
        this.addNewPaymentMethodButton = true;
        this.editbutton = false;
        //this.editafterapply = true;
      }

      if (this.firstCreditCard[0].isPrimary == true) {
        this.editafterapply = false;
        this.editafterapplysecond = true;
        this.ifFirstCreditCardPrimaryResponsive = true;
      } else {
        this.editafterapply = true;
        this.editafterapplysecond = false;
        this.ifSecondCreditCardPrimaryResponsive = true;
      }

      this.isCreditCardInvestorText = true;
      //this.saveCreditCardButton = false;
      this.removebutton = true;
      this.cancelCreditCardButton = false;
      this.secondCreditCardAddButton = false;
    },

    CreditCardUpdateCancel() {
      if (this.secondCreditCard.length > 0) {
        this.isSecondCreditCardBorderRequired = true;
        this.addNewPaymentMethodButton = false;
        this.editbutton = true;
        this.editafterapply = false;
        this.creditCardFields = false;
        this.isEditButtonClicked = false;
        this.editafterapplysecond = false;
      } else {
        this.editafterapplysecond = false;
        this.isEditButtonClicked = false;
        this.isSecondCreditCardBorderRequired = false;
        this.addNewPaymentMethodButton = false;
        this.editbutton = true;
        this.editafterapply = false;
        this.creditCardFields = false;
      }

      this.isCreditCardInvestorText = false;
      this.cancelCreditCardButton = false;
      this.removebutton = false;
      this.secondCreditCardAddButton = false;
      this.ifFirstCreditCardPrimaryResponsive = false;
      this.ifSecondCreditCardPrimaryResponsive = false;
    },

    AddNewCreditCard() {
      if (this.secondCreditCard.length > 0) {
        this.editafterapplySecond = true;
      } else {
        this.setupStripe();
        this.editafterapply = false;
        this.isSecondCreditCardBorderRequired = false;
        this.addNewPaymentMethodButton = false;
        this.creditCardFields = true;
      }

      this.cancelCreditCardButton = true;
      this.removebutton = true;
      this.secondCreditCardAddButton = true;
    },

    async setupStripe() {
      // Load Stripe with your public key
      this.stripe = await loadStripe(this.stripePublicKey);
      this.elements = this.stripe.elements();

      // Define style for the Stripe Elements
      const style = {
        base: {
          color: "#32325d",
          "::placeholder": {
            color: "#aab7c4",
          },
        },
      };

      // Create Stripe Elements for card number, expiry, and CVC
      this.cardNumberElement = this.elements.create("cardNumber", {
        style: {
          base: {
            fontSize: "14px",
            color: "#000000",
            fontFamily: '"MorningstarIntrinsic, HelveticaNeue, Helvetica Neue, Helvetica, Arial,sans-serif"',
          },
        },
        showIcon: true,
        iconStyle: "default",
        
      });
      this.cardNumberElement.mount("#card-number");

      this.cardExpiryElement = this.elements.create("cardExpiry", {
        style
        
      });
      this.cardExpiryElement.mount("#card-expiry");

      this.cardCvcElement = this.elements.create("cardCvc", { style });
      this.cardCvcElement.mount("#card-cvc");
      this.setupStripeListeners();
    },

    // Method to handle form submission
    async submitPayment() {
      window.scrollTo(0, 0);
      this.isLoading = true;
      this.btnForCreditCardLoading = true;
      this.secondCreditCardAddButton = false;
      // Create PaymentMethod using the Elements
      const { paymentMethod, error } = await this.stripe.createPaymentMethod({
        type: "card",
        card: this.cardNumberElement,
      });

      if (error) {
        // Handle the error
        this.error = error.message;
        console.log("error : " + this.error);

        return;
      }
      try {
        let URL = this.addCreditCardURL;
        URL = URL.replace("{customerId}", this.stripeIdForCC);
        URL = URL.replace("{paymentMethodId}", paymentMethod.id);
        // Send the customerId and paymentMethodId to the backend
        const response = await postData(URL);

        console.log(response.data);

        if (response && response.status === 200 && response.data) {
          // Handle successful payment (e.g., redirect to a success page)
          //console.log("Credit Card Added Successfully..........");
          this.btnForCreditCardLoading = false;
          this.secondCreditCardAddButton = false;
          this.isLoading = false;
          this.creditCardFields = false;
          this.showStateMsg("Your changes have been saved.");
          this.editafterapply = false;
          this.editafterapplysecond = false;
          this.cancelCreditCardButton = false;
          this.removebutton = false;
          this.isCreditCardInvestorText = false;
          this.editbutton = true;
          this.firstCreditCard = [];
          this.secondCreditCard = [];
          this.ifFirstCreditCardPrimary = false;
          this.ifsecondCreditCardPrimary = false;
          this.ifFirstCreditCardPrimaryResponsive = false;
          this.ifSecondCreditCardPrimaryResponsive = false;
          this.GetStripeCreditCardDetails();
        } else {
          // Handle failure response from backend
          this.btnForCreditCardLoading = false;
          this.secondCreditCardAddButton = false;
          this.isLoading = false;
          this.creditCardFields = false;
          this.showErrorStateMsg(response.data.ResponseMessage);
          this.editafterapply = false;
          this.editafterapplysecond = false;
          this.cancelCreditCardButton = false;
          this.removebutton = false;
          this.isCreditCardInvestorText = false;
          this.editbutton = true;
          this.firstCreditCard = [];
          this.secondCreditCard = [];
          this.ifFirstCreditCardPrimary = false;
          this.ifsecondCreditCardPrimary = false;
          this.ifFirstCreditCardPrimaryResponsive = false;
          this.ifSecondCreditCardPrimaryResponsive = false;
          this.GetStripeCreditCardDetails();
        }
      } catch (err) {
        // Handle API call error
        //this.error = "An error occurred while processing your payment.";
        this.showErrorStateMsg("An error occurred while processing your payment.");
      }
    },

    setPrimarySecondCreditCard() {
      window.scrollTo(0, 0);
      this.isLoading = true;
      let URL = this.setPrimaryCreditCardURL;
      URL = URL.replace("{customerId}", this.stripeIdForCC);
      URL = URL.replace("{paymentMethodId}", this.secondCreditCard[0].paymentMethodId);
      postData(URL)
        .then((response) => {
          this.isLoading = false; //
          if (response && response.status === 200) {
            this.isLoading = false;
            this.showStateMsg("Your changes have been saved.");
            this.editafterapplysecond = false;
            this.isCreditCardInvestorText = false;
            this.editbutton = true;
            this.secondCreditCard = [];
            this.firstCreditCard = [];
            this.ifFirstCreditCardPrimary = false;
            this.ifsecondCreditCardPrimary = false;
            this.ifFirstCreditCardPrimaryResponsive = false;
            this.ifSecondCreditCardPrimaryResponsive = false;
            this.removebutton = false;
            this.GetStripeCreditCardDetails();
          } else {
            this.showErrorStateMsg(response.ResponseMessage);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.error("Error during Set As primary request:", error);
        });
      this.customAlertSuccess = false;
    },

    setPrimaryFirstCreditCard() {
      window.scrollTo(0, 0);
      this.isLoading = true;
      let URL = this.setPrimaryCreditCardURL;
      URL = URL.replace("{customerId}", this.stripeIdForCC);
      URL = URL.replace("{paymentMethodId}", this.firstCreditCard[0].paymentMethodId);
      postData(URL)
        .then((response) => {
          this.isLoading = false; //
          if (response && response.status === 200) {
            this.isLoading = false;
            this.showStateMsg("Your changes have been saved.");
            this.editafterapply = false;
            this.isCreditCardInvestorText = false;
            this.editbutton = true;
            this.firstCreditCard = [];
            this.secondCreditCard = [];
            this.ifFirstCreditCardPrimary = false;
            this.ifsecondCreditCardPrimary = false;
            this.ifFirstCreditCardPrimaryResponsive = false;
            this.ifSecondCreditCardPrimaryResponsive = false;
            this.removebutton = false;
            this.GetStripeCreditCardDetails();
          } else {
            this.showErrorStateMsg(response.ResponseMessage);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.error("Error during Set As primary request:", error);
        });
      this.customAlertSuccess = false;
    },

    removeFirstCreditCard() {
      try {
        console.log("Card details:", JSON.stringify(this.firstCreditCard));

        // Ensure the firstCreditCard array is not empty and contains the necessary data
        if (!this.firstCreditCard || this.firstCreditCard.length === 0) {
          console.error("No card details available to delete.");
          return; // Exit early if no card details exist
        }

        // Extract the paymentMethodId from the first item in the array
        const paymentMethodId = this.firstCreditCard[0].paymentMethodId;
        if (!paymentMethodId) {
          console.error("Payment Method ID is missing in the card details.");
          return; // Exit early if there's no paymentMethodId
        }

        // Replace placeholders in the URL
        let URL = this.deleteCreditCardURL;
        URL = URL.replace("{customerId}", this.stripeIdForCC);
        URL = URL.replace("{paymentMethodId}", paymentMethodId);

        // Make the delete request using the deleteData method
        this.deleteCreditCard(URL);
      } catch (error) {
        console.error("An error occurred while removing the credit card:", error);
      }
    },

    removeSecondCreditCard() {
      try {
        //console.log("Card details:", JSON.stringify(this.secondCreditCard));

        // Ensure the secondCreditCard array is not empty and contains the necessary data
        if (!this.secondCreditCard || this.secondCreditCard.length === 0) {
          console.error("No card details available to delete.");
          return; // Exit early if no card details exist
        }

        // Extract the paymentMethodId from the first item in the array
        const paymentMethodId = this.secondCreditCard[0].paymentMethodId;
        if (!paymentMethodId) {
          console.error("Payment Method ID is missing in the card details.");
          return; // Exit early if there's no paymentMethodId
        }

        // Replace placeholders in the URL
        let URL = this.deleteCreditCardURL;
        URL = URL.replace("{customerId}", this.stripeIdForCC);
        URL = URL.replace("{paymentMethodId}", paymentMethodId);

        // Make the delete request using the deleteData method
        this.deleteCreditCard(URL);
      } catch (error) {
        console.error("An error occurred while removing the credit card:", error);
      }
    },

    deleteCreditCard(url) {
      window.scrollTo(0, 0);
      this.isLoading = true;
      postData(url)
        .then((response) => {
          this.isLoading = false;
          if (response && response.status === 200) {
            this.isLoading = false;
            this.showStateMsg("Your changes have been saved.");
            this.editafterapply = false;
            this.isCreditCardInvestorText = false;
            this.editbutton = true;
            this.isSecondCreditCardBorderRequired = false;
            this.firstCreditCard = [];
            this.secondCreditCard = [];
            this.ifFirstCreditCardPrimary = false;
            this.ifsecondCreditCardPrimary = false;
            this.ifFirstCreditCardPrimaryResponsive = false;
            this.ifSecondCreditCardPrimaryResponsive = false;
            this.removebutton = false;
            this.GetStripeCreditCardDetails();
          } else {
            this.showErrorStateMsg(response.ResponseMessage);
            // Handle failed deletion (e.g., show error message to user)
          }
        })
        .catch((error) => {
          this.isLoading = false; // Hide loading state on error
          console.error("Error during delete request:", error);
          // Optionally show a message to the user that an error occurred
        });
    },

    setupStripeListeners() {
      this.cardNumberElement.on("change", this.onCardNumberChange);
      this.cardExpiryElement.on("change", this.onCardExpiryChange);
      this.cardCvcElement.on("change", this.onCardCvcChange);
    },
 // Handle card number field validation
 onCardNumberChange(event) {
      if (event.error) {
        this.cardNumberError = "Your card number is invalid.";  // Set error message for card number
        this.isCardNumberValid = false;  // Set card number validity to false
      } else {
        this.cardNumberError = null;  // Reset error when valid
        this.isCardNumberValid = true;  // Set card number validity to true
      }
      if (event.complete && !event.error) {
        this.cardExpiryElement.focus();
      }
    },

    // Handle expiry date field validation
    onCardExpiryChange(event) {
      if (event.error) {
        this.cardExpiryError = "Your card's expiration year is invalid.";  // Set error message for expiry date
        this.isCardExpiryValid = false;  // Set expiry date validity to false
      } else {
        this.cardExpiryError = null;  // Reset error when valid
        this.isCardExpiryValid = true;  // Set expiry date validity to true
      }
      if (event.complete && !event.error) {
        this.cardCvcElement.focus();
      }
    },

    // Handle CVV field validation
    onCardCvcChange(event) {
      if (event.error) {
        this.cardCVVError = "Security code is required";  // Set error message for CVV
        this.isCardCvcValid = false;  // Set CVV validity to false
       
      } else {
        this.cardCVVError = null;  // Reset error when valid
        this.isCardCvcValid = true;  // Set CVV validity to true
      }
    },
 
    downloadInvoice(url){
      if(url){
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.click();
      }
    },
    
    noProductAccess() {
    return (this.firstCreditCard == '' && this.secondCreditCard == '');
  },
  
  showErrorCustomerMsg(responseFilter_Stripe) {
    if(responseFilter_Stripe){
    const pastDueProducts = ["FundInvestor", "StockInvestor", "DividendInvestor", "ETFInvestor"];
    const pastDueFound = [];

    pastDueProducts.forEach(productName => {
      const hasPastDue = responseFilter_Stripe.some(
        el => el.productName === productName && el.status === "past_due"
      );
      if (hasPastDue) pastDueFound.push(productName);
    });

    if (pastDueFound.length > 0) {
      const productList = pastDueFound.join(", ");
      this.bPastDueError = true;
      this.lstPastDueError = [
        `We couldn't process your payment with the credit card(s) we have on file. To avoid losing access to your ${productList} subscription, update your payment information below.`
      ];
    }
    }
  }

  },
  watch: {
    isDataTableResponsiveState() {
      this.isPrimaryTagResponsiveToggle = this.isDataTableResponsiveState;
    },
    creditCardValid(newVal) {
      this.$emit("card-validated", newVal);
    },
    txtAddress1(newVal, oldVal) {
      if (newVal.trim() != oldVal.trim()) {
        if (newVal.trim()) {
          this.Address1Error = false;
        } else {
          this.Address1Error = true;
        }
      }
    },
    txtAddress2(newVal, oldVal) {
      if (newVal.trim() != oldVal.trim()) {
        if (newVal.trim()) {
          this.Address2Error = false;
        } else {
          this.Address2Error = true;
        }
      }
    },
    txtCity(newVal, oldVal) {
      if (newVal.trim() != oldVal.trim()) {
        if (newVal.trim()) {
          this.cityError = false;
        } else {
          this.cityError = true;
        }
      }
    },
    txtZipCode(newVal, oldVal) {
      if (this.IsUserInStripe) {
        if (newVal.trim() != oldVal.trim()) {
          if (newVal.trim() && this.txtCountry) {
            if (this.txtCountry == "United States") {
              if (newVal.length == 5) {
                this.zipCodeError = false;
              } else {
                this.zipCodeError = true;
                this.txtZipCodeErrorMsg = "Zip code is not valid";
              }
            } else if (this.txtCountry == "Canada") {
              if (
                !/^[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{1}[ ]{0,1}[0-9]{1}[a-zA-Z]{1}[0-9]{1}/.test(
                  newVal.trim()
                )
              ) {
                this.zipCodeError = true;
                this.txtZipCodeErrorMsg = "Zip / Postal code is not valid";
              } else {
                this.zipCodeError = false;
              }
            } else if (
              this.txtCountry != "Canada" &&
              this.txtCountry != "United States"
            ) {
              if (newVal.trim()) {
                this.zipCodeError = false;
              } else {
                this.zipCodeError = true;
                this.txtZipCodeErrorMsg = "Zip / Postal code is not valid";
              }
            }
          } else {
            if (newVal.trim()) {
              this.zipCodeError = false;
            } else {
              this.zipCodeError = true;
              if (this.txtCountry == "United States") {
                this.txtZipCodeErrorMsg = "Zip Code is required";
              } else {
                this.txtZipCodeErrorMsg = "Zip / Postal Code is required";
              }
            }
          }
        }
      } else {
        if (newVal.trim() != oldVal.trim()) {
          if (newVal.trim() && this.txtCountry) {
            if (this.txtCountry.toUpperCase() == "USA") {
              if (newVal.length == 5) {
                this.zipCodeError = false;
              } else {
                this.zipCodeError = true;
                this.txtZipCodeErrorMsg = "Zip code is not valid";
              }
            } else if (this.txtCountry.toUpperCase() == "CANADA") {
              // if (newVal.length == 6) {
              //     this.zipCodeError = false;
              // } else {
              //     this.zipCodeError = true;
              //     this.txtZipCodeErrorMsg = "Zip / Postal code is not valid";
              // }
              if (
                !/^[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{1}[ ]{0,1}[0-9]{1}[a-zA-Z]{1}[0-9]{1}/.test(
                  newVal.trim()
                )
              ) {
                this.zipCodeError = true;
                this.txtZipCodeErrorMsg = "Zip / Postal code is not valid";
              } else {
                this.zipCodeError = false;
              }
            } else if (
              this.txtCountry.toUpperCase() != "CANADA" &&
              this.txtCountry.toUpperCase() != "USA"
            ) {
              if (newVal.trim()) {
                this.zipCodeError = false;
              } else {
                this.zipCodeError = true;
                this.txtZipCodeErrorMsg = "Zip / Postal code is not valid";
              }
            }
          } else {
            if (newVal.trim()) {
              this.zipCodeError = false;
            } else {
              this.zipCodeError = true;
              if (this.txtCountry.toUpperCase() == "USA") {
                this.txtZipCodeErrorMsg = "Zip Code is required";
              } else {
                this.txtZipCodeErrorMsg = "Zip / Postal Code is required";
              }
            }
          }
        }
      }
    },
    txtCountry(newVal, oldVal) {
      if (this.IsUserInStripe) {
        if (newVal != oldVal) {
          if (newVal) {
            this.CountryError = false;
            if (newVal == "United States") {
              this.txtZipCodeErrorMsg = "Zip Code is required";
            } else {
              this.txtZipCodeErrorMsg = "Zip / Postal Code is required";
            }
          } else {
            this.CountryError = true;
          }
        }
      } else {
        if (newVal != oldVal) {
          if (newVal) {
            this.CountryError = false;
            if (newVal.toUpperCase() == "USA") {
              this.txtZipCodeErrorMsg = "Zip Code is required";
            } else {
              this.txtZipCodeErrorMsg = "Zip / Postal Code is required";
            }
          } else {
            this.CountryError = true;
          }
        }
      }
    },
    txtUsaState(newVal, oldVal) {
      if (newVal != oldVal) {
        if (newVal) {
          this.USAStateError = false;
        } else {
          this.USAStateError = true;
        }
      }
    },
  },
};
</script>

<style scoped>
body,
body * {
  font-family: "MorningstarIntrinsic", HelveticaNeue, "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.stripe-payment-form-label {
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0%;
  margin-bottom: 6px;
}

.flex-container {
  display: flex;
  gap: 17px;
  margin-top: 35px;
}
.flex-item {
  flex: 1;
}
.stripe-element {
  font-family: UniversNext for MORN;
  margin-top: 5.5px;
  border: none;
  border-radius: 0;
  background-color: #e5e5e5;
  padding: 6px;
  background-clip: padding-box;
  box-shadow: inset 0 -1px 0 0 #808080;
  color: #1e1e1e;
}
.required {
  color: #f00;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
}

.error-for-date {
  color: #f00;
  height: 25px;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
}

.payment-method-text-and-remove-button-container {
  display: flex;
  justify-content: space-between;
}

.remove-button-on-credit-card-container {
  margin-top: -75px;
  margin-right: -10px;
}

.error-for-cvc {
  color: #f00;
  height: 25px;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
}

.success {
  color: green;
}
.status-message {
  margin-bottom: 10px;
}

/*start credit card css*/
@media only screen and (min-width: 480px) and (max-width: 6000px) {
  .payment-heading {
    margin-bottom: 7.5px;
    color: #1e1e1e;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0%;
  }

  .subscription-main-container {
    margin: 23px;
  }

  .first-credit-card-edit-button {
    margin-left: auto;
    padding-left: auto;
    padding-top: 18px;
    margin-top: -75px;
  }

  .investor-subscriber-credit-card-not-changes-text-div {
  width: 95%;
    margin-top: 10px;
    margin-bottom: 28px;
  }
  .add-new-payment-method-container {
    margin-top: 37px;
    margin-bottom: 1px;
  }

  .stripe-payment-form {
    margin-top: 23.85px;
  }

  .error {
    position: absolute;
    color: #f00;
    padding-top: 3px;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
  }

  .border-for-credit-cards {
    border: 1px solid #e5e5e5;
    margin-top: 20px;
    margin-bottom: 15px;
  }
}

@media only screen and (min-width: 0px) and (max-width: 480px) {
  .payment-heading {
    margin-bottom: 2px;
    color: #1e1e1e;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0%;
  }

  .subscription-main-container {
    margin: 21px;
  }

  .first-credit-card-edit-button {
    margin-left: auto;
    padding-left: auto;
    padding-top: 21px;
    margin-top: -70px;
  }

  .investor-subscriber-credit-card-not-changes-text-div {
    width: 95%;
    margin-top: 11.5px;
    margin-bottom: 28px;
  }
  .add-new-payment-method-container {
    margin-top: 43px;
    margin-bottom: 1px;
  }
  .stripe-payment-form {
    margin-top: 16px;
  }

  .error {
    position: absolute;
    color: #f00;
    padding-top: 3px;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
  }

  .border-for-credit-cards {
    border: 1px solid #e5e5e5;
    margin-top: 15px;
    margin-bottom: 15px;
  }
}

.investor-subscriber-credit-card-not-changes-text-container {
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #5e5e5e;
}

.second-credit-card-number-container {
  width: 116px;
}

.first-credit-card-number-container {
  width: 116px;
}

.primary-tag-for-first-card {
  justify-content: flex-start;
  padding-left: 10px;
  display: flex;
}

.credit-card-number-text {
  color: #1e1e1e;

  font-weight: 300;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: 0%;
}

.first-credit-card-text {
  display: flex;

  align-items: center;
  width: 100%;
}

.edit-text-after-apply {
  font-weight: 300;
  font-size: 16px;
  line-height: 21px;
  text-align: right;

  color: #5e5e5e;
}

.exp-date-and-security-code-container {
  width: 100%;
  display: flex;
}

.expiration-date-container {
  width: 50%;
  margin-right: 18px;
  margin-top: 35px;
}

.security-code-container {
  width: 50%;
  margin-top: 35px;
}

.credit-card-below-text {
  margin-top: 25px;
  margin-bottom: 39px;
}

.credit-card-below-text-para {
  color: #5e5e5e;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
}

.card-number-container {
  height: 52px;
  margin-top: 24.85px;
}

.card-number-error-container {
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;

  color: #ca0000;
  margin-top: -10px;
}

.set-primary-button-container {
  margin-top: -5px;
  margin-right: 12px;
}

.second-credit-card-edit-button {
  display: flex;

  justify-content: space-between;

  width: 100%;
}

.primary-tag-for-second-card {
  margin-right: auto;
  padding-left: 9px;
}

.edit-and-remove-for-first-cc-container {
  display: flex;
  margin-left: auto;
}

.first-credit-card-remove-container {
  margin-top: -5px;
}

/*end credit card css*/

.subscription-heading-top {
  color: var(--text-primary, #1e1e1e);
  /* Heading/Level 7: Light */
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 21px;
}
.subscription-heading {
  color: var(--text-primary, #1e1e1e);
  /* Heading/Level 7: Light */
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 21px;
}

.subscription-box {
  border-radius: 6px;
  border: 1px solid #ccc;
  background: var(--background-primary, #fff);
  width: 100%;
  margin-top: 10px;
}

.subscription-box-payment-method {
  border-radius: 6px;
  border: 1px solid #ccc;
  background: var(--background-primary, #fff);
  width: 100%;
  margin-top: 10px;
  margin-bottom: 24px;
}

.subscription-product-title {
  color: var(--text-primary, #1e1e1e);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
}

.subscription-term {
  color: var(--text-primary, #1e1e1e);
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 21px;
}

.subscription-border {
  border: 1px solid #e5e5e5;
  margin-top: 20px;
}

.subscription-loader {
  width: "276px";
  height: "69px";
}

.subscription-box {
  border-radius: 6px;
  border: 1px solid #ccc;
  background: var(--background-primary, #fff);
  width: 100%;
  /*  height: 88px;*/
}

.subscription-box-payment-method {
  border-radius: 6px;
  border: 1px solid #ccc;
  background: var(--background-primary, #fff);
  width: 100%;
  /*  height: 88px;*/
}

.subscription-address-heading {
  color: var(--text-secondary, #5e5e5e);
  font-size: 14px;
  line-height: 18px;
  font-weight: 700;
}
.subscription-address-secondary {
  color: var(--text-secondary, #5e5e5e);
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
}
.subscription-address-support-links {
  color: #000000 !important;
}
.subscription-secondarytext {
  color: var(--text-secondary, #5e5e5e);
  font-size: 14px;
  line-height: 18px;
}

.subscription-secondarytext:hover {
  cursor: pointer;
}
.subscription-heading {
  color: var(--text-primary, #1e1e1e);
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
}
.subscription-text {
  color: var(--text-primary, #1e1e1e);
  font-size: 16px;
  font-weight: 300;
  line-height: 21px;
}
.subscription-address-editbox {
  border-radius: 6px;
  border: 1px solid #ccc;
  background: var(--background-primary, #fff);
  width: 100%;
  /* height: 280px;*/
  /*  height: 88px;*/
}
.subscription-address-btn {
  float: inherit;
  margin-top: 40px;
  margin-right: 17px;
}
.subscription-address-inside-flex {
  width: 100%;
}
.subscription-heading-textbox {
  font-size: 14px;
}
.subscription-forms-error {
  color: #ca0000;
  font-size:14px;
}
.subscription-city {
  margin-top: 36px;
}
.subscription-secondarytext:hover {
  cursor: pointer !important;
}
.subscription-active-color {
  border-color: #006fba !important;
}
.subscription-first-product {
  margin-top: 16px;
}
.subscription-other-product {
  margin-top: 32px;
}
.subscription-separator {
  margin: 0 4px;
  color: #cccccc;
}

.subscription-promo {
  color: #5e5e5e;
  font-weight: 300;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: 0%;
}

.subscription-view-invoice {
  font-weight: 300;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: 0%;
  color: var(--text-secondary, #5e5e5e);
  cursor: pointer;
}

.subscription-text-layout-grid-container{
  margin-top: 11px;
}

@media only screen and (min-width: 350px) {
.cancel-subscription-text-container{

  font-weight: 300;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: 0%;
  color: var(--text-secondary, #5e5e5e);
  cursor: pointer;
}
}
@media only screen and (max-width: 350px) {
.cancel-subscription-text-container{
  font-weight: 300;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0%;
  color: var(--text-secondary, #5e5e5e);
  cursor: pointer;
}
}
@media only screen and (min-width: 0px) and (max-width: 600px) {
  .subscription-alert {
    position: absolute;
    top: 19%;
    left: 10px;
    width: 95%;
    z-index: 99999999999;
  }

  .subscription-address-editdiv {
    width: 125px;
    display: inline-flex;
    margin-left: 27px;
    margin-bottom: 10px;
  }

  .subscription-city {
    margin-top: 10px;
  }

  .subscription-address-editbox {
    border-radius: 6px;
    border: 1px solid #ccc;
    background: var(--background-primary, #fff);
    width: 100%;
    /* height: 380px;*/
    /*  height: 88px;*/
  }

  .subscription-address-btn {
    float: inherit;
    margin-top: 40px;
    margin-right: 17px;
  }
}
@media only screen and (min-width: 0px) and (max-width: 390px) {
  .subscription-address-editdiv {
    width: 92% !important;
    display: inline-flex !important;
    margin-left: 23px !important;
  }

  .remove-number-button {
    margin-left: -13px;
  }
}
@media only screen and (min-width: 390px) and (max-width: 400px) {
  .subscription-address-editdiv {
    width: 92% !important;
    display: inline-flex !important;
    margin-left: 23px !important;
  }

  .subscription-address-btn {
    float: inherit !important;
    margin-top: 40px !important;
    margin-right: 17px !important;
  }
}
@media only screen and (min-width: 401px) and (max-width: 430px) {
  .subscription-address-editdiv {
    width: 92% !important;
    display: inline-flex !important;
    margin-left: 25px !important;
  }

  .subscription-address-btn {
    float: inherit !important;
    margin-top: 40px !important;
    margin-right: 17px !important;
  }
}
@media only screen and (min-width: 601px) and (max-width: 768px) {
  .subscription-address-editdiv {
    width: 125px;
    display: inline-flex;
    margin-left: 23px;
  }

  .subscription-address-btn {
    float: inherit;
    margin-top: 40px;
    margin-right: 17px;
  }

  .subscription-city {
    margin-top: 10px;
  }

  .subscription-address-editbox {
    border-radius: 6px;
    border: 1px solid #ccc;
    background: var(--background-primary, #fff);
    width: 100%;
    /* height: 400px;*/
  }

  .remove-number-button {
    margin-top: 53px;
  }
}
@media only screen and (min-width: 650px) and (max-width: 700px) {
  .subscription-address-editdiv {
    width: 150px !important;
    display: inline-flex !important;
    margin-left: 23px !important;
  }

  .subscription-address-btn {
    float: inherit !important;
    margin-top: 40px !important;
    margin-right: 17px !important;
  }
}
@media only screen and (min-width: 730px) and (max-width: 790px) {
  .subscription-address-editdiv {
    width: 140px !important;
    display: inline-flex !important;
    margin-left: 23px !important;
  }

  .subscription-address-btn {
    float: inherit !important;
    margin-top: 40px !important;
    margin-right: 17px !important;
  }
}
@media only screen and (min-width: 769px) and (max-width: 1000px) {
  .subscription-address-editdiv {
    width: 150px;
    display: inline-flex;
    margin-left: 23px;
  }

  .subscription-address-btn {
    float: inherit;
    margin-top: 40px;
    margin-right: 17px;
  }
}
@media only screen and (min-width: 1001px) and (max-width: 1200px) {
  .subscription-address-editdiv {
    width: 125px;
    display: inline-flex;
    margin-left: 23px;
  }

  .subscription-address-btn {
    float: inherit;
    margin-top: 40px;
    margin-right: 17px;
  }
}
@media only screen and (min-width: 1201px) and (max-width: 6000px) {
  .subscription-address-editbox {
    border-radius: 6px;
    border: 1px solid #ccc;
    background: var(--background-primary, #fff);
    width: 100%;
    /*height: 360px;*/
  }

  .subscription-address-editdiv {
    width: 160px;
    display: inline-flex;
    margin-left: 23px;
    /* margin-left: 23px;*/
    /*margin-right: 23px;*/
  }

  .subscription-address-btn {
    float: inherit;
    margin-top: 40px;
    margin-right: 12px;
  }
}
.subscription-support-alert {
    width: 100%;
    margin-top: 12px;
    margin-bottom: 12px;
    
}

</style>
<style lang="scss">
@import "@mds/constants";
@import "@mds/icon/src/icon_mixins";

.exclaim-circle-fill {
  /* @include mds-icon-color(#FFFF00);*/
  @include mds-icon-color(#f5c400);
  padding-top: 1.8px;
}
</style>
<style>
.subscription-list-style::before {
  color: #ababab;
  content: "•";
  left: 0;
  line-height: 19.5px;
  vertical-align: baseline;
  margin-right: 3px;
  font-size: 13px;
}
.subscription-address-support-links {
  color: #000000 !important;
}

.subscription-alert .mds-alert .mds-alert__list li::before {
  content: none;
}

.subscription-heading-textbox .mds-label__text {
  margin-bottom: 8px !important;
  font-size:14px !important;
}
.subscription-secondarytext:hover {
  cursor: pointer !important;
}
.subscription-active-color {
  border-color: #006fba !important;
}

.card-number-container > label > div {
  margin-bottom: 8px;
}

.expiration-date-container > label > div {
  margin-bottom: 8px;
}

.security-code-container > label > div {
  margin-bottom: 8px;
}

.primary-tag-for-first-card > div {
  background-color: white;
}

.primary-tag-for-second-card > div {
  background-color: white;
}

.ElementsApp .InputElement.is-invalid {
  color: black;
}

#card-number .ElementsApp .InputElement.is-invalid {
  color: #000000 !important; /* Keep the color black when invalid */
}

@media only screen and (min-width: 767px) and (max-width: 890px) {
.my-account-main > div > div > div:nth-child(2){
  max-width: 65%;
  flex-basis: 57%;
}

.my-account-main > div > div > div:nth-child(1){
  max-width: 21%;
  
}

}

@media only screen and (min-width: 767px) and (max-width: 970px) {
.subscription-text-layout-grid-container> div > div > div:nth-child(1){
  max-width: 60%;
}

.subscription-text-layout-grid-container> div > div > div:nth-child(2){
  max-width: 40%;
  flex-basis: 43%;
}

}
@media only screen and (min-width: 0px) and (max-width: 600px) {
  .subscription-billing-address-heading{
    margin-top: 0px;
    margin-left: 27px;
    font-weight:700;
    font-size:14px;
    line-height: 18px;
    color: #1E1E1E;
    position: absolute;
  }
  .subscription-billing-address-heading-hide-address2{
    margin-top: 0px;
    margin-left: 27px;
    font-weight:700;
    font-size:14px;
    line-height: 18px;
    color: #1E1E1E;
    /* position: absolute; */
  }
}
@media only screen and (min-width: 601px) and (max-width: 768px) {
  .subscription-billing-address-heading{
    margin-top: 0px;
    margin-left: 23px;
    font-weight:700;
    font-size:14px;
    line-height: 18px;
    color: #1E1E1E;
    position: absolute;
  }
  .subscription-billing-address-heading-hide-address2{
    margin-top: 0px;
    margin-left: 23px;
    font-weight:700;
    font-size:14px;
    line-height: 18px;
    color: #1E1E1E;
    /* position: absolute; */
  }
}
@media only screen and (min-width: 769px) and (max-width: 1000px) {
  .subscription-billing-address-heading{
    margin-top: -13px;
    margin-left: 23px;
    font-weight:700;
    font-size:14px;
    line-height: 18px;
    color: #1E1E1E;
    position: absolute;
  }
  .subscription-billing-address-heading-hide-address2{
    margin-top: -13px;
    margin-left: 23px;
    font-weight:700;
    font-size:14px;
    line-height: 18px;
    color: #1E1E1E;
    /* position: absolute; */
  }
}
@media only screen and (min-width: 1001px) and (max-width: 1200px) {
  .subscription-billing-address-heading{
    margin-top: 20px;
    margin-left: 23px;
    font-weight:700;
    font-size:14px;
    line-height: 18px;
    color: #1E1E1E;
    position: absolute;
    
  }
  .subscription-billing-address-heading-hide-address2{
    margin-top: 20px;
    margin-left: 23px;
    font-weight:700;
    font-size:14px;
    line-height: 18px;
    color: #1E1E1E;
    position: absolute;
    
  }
}
@media only screen and (min-width: 1201px) and (max-width: 6001px) {
  .subscription-billing-address-heading{
    margin-top: 20px;
    margin-left: 23px;
    font-weight:700;
    font-size:14px;
    line-height: 18px;
    color: #1E1E1E;
    position: absolute;
  }
  .subscription-billing-address-heading-hide-address2 {
        margin-top: 20px;
        margin-left: 23px;
        font-weight: 700;
        font-size: 14px;
        line-height: 18px;
        color: #1E1E1E;
        /* position: absolute; */
    }
}
/* .mds-label .mds-label__text{
    font-size: 14px !important;
} */

 .subscription-address-custom-css{
  padding-top: 9px;
 }
 .subscription-support-alert .mds-alert .mds-alert__list li::before {
   content: none;
}
</style>
